import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { ImageBoxEditorComponent } from 'app/components/image-box-editor/image-box-editor.component';
import { ImageBoxEditorData } from 'app/components/image-box-editor/typings';
import downloadjs from 'downloadjs';
import {
  NbToastrService,
  NbDialogService,
  NbSidebarService,
} from '@nebular/theme';
import { AddCommentsComponent } from './add-comments/add-comments.component';
import { InfoComponent } from './info/info.component';
import { DialogComponent } from './dialog-popup/dialog.component';
import { Auth } from 'aws-amplify';
import { JobService } from '../../services/job.service';
import { MomentService } from '../../services/moment.service';
import { v4 as uuidv4 } from 'uuid';
import { Helper } from './helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TextBlock } from 'types';
import { s3SignedImageUrlToBase64, loadImageFromUrlAsPromise, blobToBase64, dataURItoBlob, getFileNameAndExtOfPath, getImageSizeFromDataURL } from '../../utils/file';
import { HttpEvent, HttpHeaders, HttpParams, HttpRequest, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { convertArrayofArrayToCSV } from '../../services/csv';
const datePattern =
  /(\b(\d{2}|\d{1})\s*([/]|[-]|[.])\s*(\d{2}|\d{1})\s*([/]|[-]|[.])\s*(20\d{2}|\d{2}))|((20\d{2}|\d{2}) *[-] *(\b(0?[1-9]|1[012])\b) *[-] *(0[1-9]|[12][0-9]|3[01]))|(\b(\d{2}|\d{1}) *(th|rd|st|nd)? *[-]?\s*((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*[-]?\s*(20\d{2}|\d{2}))|((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)? *(\d{2}|\d{1}) *(th|rd|st|nd)? *(20(d{2}|\d{2})))|(((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?) * \b(\d{2}|\d{1})\b([,])? *(20\d{2}|\d{2}))/gi;
const datePatternWithoutYear =
  /\b(\d{2}|\d{1})\s*([/]|[-]|[.])?\s*((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*\b/gi;
const yearWidth = 35;

const standardCanvasWidth = 750;
const standardCanvasHeight = 1066;

const rightCanvasOfstY = 5;
import * as XLSX from 'xlsx';
/**
 * The set contains a set of string which serve as indicators
 * A cell containing one of the strings in the set means
 * no need to auto add date
 * @type {Set<string>}
 */
const NO_AUTO_ADD_DATE = new Set([
  'CLOSING BALANCE',
  'BALANCE CARRIED FORWARD'
])

@Component({
  selector: 'ngx-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss'],
})
export class JobDetailsComponent implements OnDestroy, AfterViewInit, OnInit {
  @ViewChild('leftImageCanvas') leftImageCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('rightCanvas') rightCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('imageBoxEditor') imageBoxEditor: ImageBoxEditorComponent;
  @ViewChild('header') header;
  public rightContext;
  public redrawContext;
  public leftContext;
  loading = true;
  imgSrc: any = [];
  leftImage;
  wordBlocks = [];
  redrawnImages = [];
  redrawClick = false;
  // imgSrc: any = ['../../assets/testResults/Yarrow-1.png', '../../assets/testResults/Yarrow-2.png'];
  imageUrl: any;
  pageBoundingPoly = [];
  pageIndex = 0;
  apiRespImages = [];
  apiError = null;
  jobId;
  boxEditorData: ImageBoxEditorData;
  extractedRes: any;
  columnHeaders: any = [];
  extractedResPreserved: any;
  displayStandardFields = true;
  keys = [
    'bankName',
    'bsb',
    'accountNumber',
    'accountName',
    'clientName',
    'clientAddress',
    'openingStatementDate',
    'closingStatementDate',
    'openingBalance',
    'closingBalance',
    'totalCredits',
    'totalDebits'
  ];
  selectedBox;
  status;
  comments;
  fileName;
  jobOwner;
  extractedResKey;
  statusColor;
  toastrPosition: any = 'top-right';
  drawInit = false;
  projectName;
  imgURLs = [];
  imageKeys = [];
  errorPages = [];
  errorPage = 0;
  errorPageClick = 0;
  errorPagesConsolidated = [];
  balanceCheckErrorPages = [];
  userEmail: string;
  changes = [];
  fetchAllTables = false;
  tableBounds = [];
  showWordBlocks = false;
  generalErrors = [];
  splitCombinedColumnsCheck = false;
  s3SignedPdfFile;
  extractedResultsFull;
  startPageNos = [];
  statementNo = 0;
  skewFactorX = 0;
  skewFactorY = 0;
  deskewedImageS3Keys = [];
  userSwitchToNextStatement = false;
  lineDraw = false;
  fixSuggestions = [];
  pdfFailed: boolean = false;
  pdfAbsent: boolean = false;
  selectedInvoice: any = null;
  selectedInvoiceFormatted: any = null;


  private readonly destroy = new Subject<void>();

  constructor(
    private api: ApiService,
    private activeRoute: ActivatedRoute,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private sidebarService: NbSidebarService,
    private jobService: JobService,
    private http: HttpClient
  ) {
    // this.activeRoute.params.subscribe(async (params) => {
    //   this.jobId = params['id'];
    //   await this.getJob(this.jobId);
    //   this.userEmail = (await Auth.currentUserInfo()).attributes.email;
    // });
  }

  ngOnDestroy(): void {
    this.jobService.setValues(null);
    this.destroy.next();
    this.destroy.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sidebarService.compact('menu-sidebar');
    });
  }

  async ngOnInit() {
    this.activeRoute.params.subscribe(async (params) => {
      this.jobId = params['id'];
      await this.getJob(this.jobId);
      this.userEmail = (await Auth.currentUserInfo()).attributes.email;
    });
    
    this.jobService.layerButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe(() => this.layerButton());
    
    this.jobService.horizontalButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe(() =>
      this.horizontalButton(),
    );

    this.jobService.verticalButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe(() =>
      this.verticalButton(),
    );

    this.jobService.undoButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe(() => this.undoButton());

    this.jobService.proceedButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe(() => this.proceedButton());

    this.jobService.undoTableChangesTrigger$.pipe(takeUntil(this.destroy)).subscribe(() =>
      this.undoTableChanges(),
    );

    this.jobService.changePageTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.changePage(res, null),
    );
    
    this.jobService.jobVerifiedStatusTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.jobVerifiedStatus(res),
    );

    this.jobService.exportTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) => this.export(res));

    this.jobService.onPopverAddCommentClickTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.onPopverAddCommentClick(),
    );

    this.jobService.onReprocessClickTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.onReprocessClick(),
    );

    this.jobService.proceedToNextJobTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.proceedToNextJob(res),
    );
 
    this.jobService.headerToggleTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.headerToggle(res),
    );

    this.jobService.infoButtonTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.onPopverInfoClick(),
    );

    this.jobService.deskewTTrigger$.pipe(takeUntil(this.destroy)).subscribe((res) =>
      this.deskewImage(res),
    );
  }

  getKeys(obj: any) {
    return Object.keys(obj);
  }

  formatKey(key: string): string {
    let formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
    formattedKey = formattedKey.replace(/\bVendor\b/g, 'Provider');
    formattedKey = formattedKey.replace(/\bReceiver\b/g, 'Patient');
    return formattedKey;
  }

  /**
   * 
   * @param {number} jobId
   * @param {number} currentStatementNo - If multiple statements are combined, display the selected statement based on the current statement number.
   */
  async getJob(jobId, reinit = false, currentStatementNo = 0) {
    const body = { jobId };
    this.api.getJob(body).subscribe(async (res) => {
      this.status = res.status;
      this.imgURLs = res.imgURLs;
      this.imageKeys = res.imageKeys;
      this.comments = res.comments;
      this.fileName = res.fileName;
      this.projectName = res.projectName;
      this.jobOwner = res.userEmail;
      this.extractedResKey = res.extractedResKey;
      this.setVerificationStatusColor();
      this.s3SignedPdfFile = res.s3SignedPdfFile;
      const initData = await this.api.downloadJSONFromS3(res.s3SignedExtractedResults).toPromise();
      function removeSymbolsFromKeysInArray(jsonArray) {
        return jsonArray.map(obj => {
          const newObj = {};
          for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
              // Remove symbols from the key
              const newKey = key.replace(/[^a-zA-Z0-9]/g, '');
              newObj[newKey] = obj[key];
            }
          }
          return newObj;
        });
      }
      this.extractedResultsFull = removeSymbolsFromKeysInArray(initData);
      console.log('this.extractedResultsFull', this.extractedResultsFull)
      this.selectedInvoice = this.extractedResultsFull.find(invoice => invoice.lineItems && invoice.lineItems.length > 0) || this.extractedResultsFull[0];
      console.log('this.selectedInvoice', this.selectedInvoice)
      if (this.selectedInvoice.receiverPatientName) {
        this.selectedInvoice.receiverName = this.selectedInvoice.receiverPatientName;
      } else if (this.selectedInvoice.receiverPatient) {
        this.selectedInvoice.receiverName = this.selectedInvoice.receiverPatient;
      }

      if (this.selectedInvoice.provider && !/\d/.test(this.selectedInvoice.provider)) {
        this.selectedInvoice.vendorName = this.selectedInvoice.provider;
      }
      
      // Function to add missing fields to selectedInvoice
      function addMissingFields(selectedInvoice, allInvoices) {
        allInvoices.forEach(invoice => {
            if (invoice !== selectedInvoice) {
                Object.keys(invoice).forEach(key => {
                    if (!selectedInvoice.hasOwnProperty(key)) {
                        selectedInvoice[key] = invoice[key];
                    }
                });
            }
        });
      }

      // Add missing fields from all other invoices to the selected invoice
      addMissingFields(this.selectedInvoice, this.extractedResultsFull);

      if (this.selectedInvoice.pt) {
        this.selectedInvoice.receiverName = this.selectedInvoice.pt;
      } else if (this.selectedInvoice.re) {
        this.selectedInvoice.receiverName = this.selectedInvoice.re;
      }

      if (!this.selectedInvoice.bsb) {
        Object.keys(this.selectedInvoice).forEach(key => {
          // Check if the key contains 'Bsb' and if the corresponding value contains a number
          if (key.includes('Bsb') && this.selectedInvoice[key] && /\d+/.test(this.selectedInvoice[key])) {
            // Assign the value to this.selectedInvoice.bsb if it's not already assigned
            if (!this.selectedInvoice.bsb) {
              this.selectedInvoice.bsb = this.selectedInvoice[key];
            }
          }
        });
      }

      if (this.selectedInvoice.lineItems) {
        for (let i = 0; i < this.selectedInvoice.lineItems.length; i++) {
          const hasDateKey = Object.keys(this.selectedInvoice.lineItems[i]).some(key => key.toLowerCase().includes('date'));
          if (!hasDateKey) {
            const priorityKeys = ['receiptdate', 'invoicedate', 'date']; 
            for (const key of priorityKeys) {
              const dateEntry = Object.entries(this.selectedInvoice).find(
                ([entryKey, value]) => entryKey.toLowerCase().includes(key)
              );
    
              if (dateEntry) {
                const [dateKey, dateValue] = dateEntry;
                this.selectedInvoice.lineItems[i]['date'] = dateValue;
                break; // Stop after finding the first matching entry
              }
            }
          }
          if (this.selectedInvoice.lineItems[i])
          delete this.selectedInvoice.lineItems[i].expenseRow
        }
      }
      interface Invoice {
        [key: string]: any;
      }
      
      const keyItemKeys: { [key: string]: string[] } = {
        "vendorName": ["vendorName"],
        "vendorAbnNumber": ["vendorAbnNumber"],
        "vendorEmail": ["vendorEmail", "email"],
        "accountName": ["accountName:", "A/c Name", "vendorAccountName"],
        "accountNumber": ["accountNumber", "A/c No.", 'accountNo', 'ACC:', 'accNo', 'acctNo', 'Acct', 'account:'],
        "bsb": ["bsb:", "BSB"],
        "invoiceReceiptId": ['invoiceNo', "invoiceReceiptId", "File"],
        // "invoiceReceiptDate": ["invoiceReceiptDate"],
        "receiverName": ["receiverName"],
        // "receiverAddress": ["receiverAddress"]
      };
      
      // Create the output structure
      const output = {
        keyItems: {} as { [key: string]: any },
        otherItems: {} as { [key: string]: any },
        lineItems: [] as any[]
      };
      
      // Function to normalize keys by stripping whitespace and special characters
      function normalizeKey(key: string): string {
        return key.replace(/[\s:]/g, '').toLowerCase();
      }
      // Function to find the key from the mapping using the normalized key
      function findKeyInMapping(key: string, mapping: { [key: string]: string[] }): string | null {
        const normalizedKey = normalizeKey(key);
        for (const [standardKey, variants] of Object.entries(mapping)) {
          if (variants.map(normalizeKey).includes(normalizedKey)) {
            return standardKey;
          }
        }
        return null;
      }
      
      // Ensure this.selectedInvoice is typed
      const selectedInvoice: Invoice = this.selectedInvoice;
      
      for (let [key, value] of Object.entries(selectedInvoice)) {
        const mappedKey = findKeyInMapping(key, keyItemKeys);
        if (mappedKey) {
          if (mappedKey === 'bsb' && value) {
            value = value.replace(/\D/g, '');
          }
          output.keyItems[mappedKey] = value;
        } else if (key !== "lineItems") {
          output.otherItems[key] = value;
        }
      }
      
      if (selectedInvoice.lineItems) {
        output.lineItems = [...selectedInvoice.lineItems];
      }

      if (!output.keyItems['accountName'] && output.keyItems['vendorName']) {
        output.keyItems.accountName = output.keyItems['vendorName']
      }

      if (output.keyItems['accountName']) {
        output.keyItems['accountName'] = output.keyItems['accountName'].replace('A/C', '')
      }

      function sortJsonByKeyOrder(json, keyOrder) {
        const sortedJson = {};
        Object.keys(keyOrder).forEach(key => {
            if (json[key]) {
                sortedJson[key] = json[key];
            }
        });
        return sortedJson;
      }

      output.keyItems = sortJsonByKeyOrder(output.keyItems, keyItemKeys);


      this.selectedInvoiceFormatted = output;
      this.loading = false;
      await this.injectToHeaderToolbar();
      // const extractedRes = Array.isArray(this.extractedResultsFull) ? this.extractedResultsFull[currentStatementNo] : this.extractedResultsFull;

      // if (Array.isArray(this.extractedResultsFull)) {
      //   this.startPageNos = this.extractedResultsFull.map(item => item.startPageNo);
      //   this.pageBoundingPoly = this.extractedResultsFull.reduce((acc, item) => acc.concat(item.pageBoundingPoly), this.pageBoundingPoly);
      //   this.extractedResultsFull.forEach(result => {
      //     if (!result.resizedTextAnnotationsResolution) {
      //         result = this.resizeResolution(result, standardCanvasWidth, standardCanvasHeight, false);
      //         result.wordBlocks = this.resizeResolutionV2(result.wordBlocks, standardCanvasWidth, standardCanvasHeight, false);
      //     }
      //     const suggestions = this.identifyFixSuggestions(result);
      //     if (suggestions.length > 0) {
      //         this.fixSuggestions = this.fixSuggestions.concat(suggestions);
      //     }
      //   });
      // } else {
      //   const resizedTextAnnotationsResolution = this.extractedResultsFull.resizedTextAnnotationsResolution ? true : false;
      //   this.pageBoundingPoly = this.extractedResultsFull.pageBoundingPoly; // Fix - to sort by order
      //   this.extractedResultsFull = !resizedTextAnnotationsResolution ? this.resizeResolution(this.extractedResultsFull, standardCanvasWidth, standardCanvasHeight, false) : this.extractedResultsFull;
      //   this.extractedResultsFull.wordBlocks = !resizedTextAnnotationsResolution ? this.resizeResolutionV2(this.extractedResultsFull.wordBlocks, standardCanvasWidth, standardCanvasHeight, false) : this.extractedResultsFull.wordBlocks;
      //   this.fixSuggestions = this.identifyFixSuggestions(this.extractedResultsFull);
      // }

      // if (this.fixSuggestions.length > 0) {
      //   this.dialogService.open(DialogComponent, {
      //     context: {
      //       body: "To remove these suggestions, click outside the table. To apply fixes, click the 'Proceed' button on the top bar. Avoid dragging cells until fixes are applied.",
      //       header: "Identified fixes for tables on certain pages, highlighted as Orange lines.",
      //       dialogType: "info",
      //     },
      //     closeOnBackdropClick: false,
      //   });
      // }

      // await this.setValues(reinit, this.extractedResultsFull, true);

      if (!reinit) {
        if (res.deleted) {
          this.dialogService.open(DialogComponent, {
            context: {
              body: 'This job has been deleted.',
              header: "Warning",
              dialogType: "info",
            },
            closeOnBackdropClick: false,
          });
        }
        // this.deskewedImageS3Keys = Array.from({ length: this.s3SignedPdfFile.length }).fill(null);
        // for (const img of this.s3SignedPdfFile) {
        //   const blob = await (await fetch(img)).blob();
        //   this.imgSrc.push(await blobToBase64(blob));
        // }
      }
    });
  }

  async setValues(reinit, extractedRes, isInitialLoading = false) {
    if (this.projectName.match(/alltables/i)) {
      this.fetchAllTables = true;
      this.displayStandardFields = false;
      this.header.nativeElement.style.zIndex = 1;
    }
    extractedRes.openingStatementDate = typeof(extractedRes.openingStatementDate) === 'string' ? this.createDate(extractedRes.openingStatementDate) : extractedRes.openingStatementDate;
    extractedRes.closingStatementDate = typeof(extractedRes.closingStatementDate) === 'string' ? this.createDate(extractedRes.closingStatementDate) : extractedRes.closingStatementDate;
    if (
      extractedRes &&
      extractedRes.transactionDetails &&
      extractedRes.transactionDetails.length > 0
    ) {
      extractedRes.transactionDetails = [...extractedRes.transactionDetails].sort((a: any, b: any) => a.pageIndex - b.pageIndex);
    }
    this.extractedRes = extractedRes;
    this.wordBlocks = extractedRes.wordBlocks ? extractedRes.wordBlocks : [];
    this.extractedResPreserved = this.extractedRes;
    this.updateCanvasOnbothSides(reinit, isInitialLoading);
  }

  async updateCanvasOnbothSides(reinit, isInitialLoading = false) {
    // if (!reinit) {
    //   const targetImage = this.imgSrc[this.pageIndex] ? this.imgSrc[this.pageIndex] : await s3SignedImageUrlToBase64(this.s3SignedImageFiles[this.pageIndex]);
    //   const img = await loadImageFromUrlAsPromise(targetImage)
    //   this.leftImage = img;
    //   this.loading = false;
    //   this.leftCanvas(img, this.leftImageCanvas.nativeElement);
    // }
    // this.drawCanvas(reinit, isInitialLoading);
  }

  async changePage(e, path) {
    this.skewFactorX = 0;
    this.skewFactorY = 0;
    this.loading = true;
    const i = typeof e === 'object' ? e.pageNumber : e;
    this.selectedBox = null;
    if (i < 1 && !this.fetchAllTables) {
      this.header.nativeElement.style.zIndex = 2;
      this.displayStandardFields = true;
    } else {
      this.header.nativeElement.style.zIndex = 1;
      this.displayStandardFields = false;
    }
    this.rightContext.clearRect(0, 0, this.rightCanvas.nativeElement.width, this.rightCanvas.nativeElement.height);

    this.leftContext.clearRect(0, 0, this.leftImageCanvas.nativeElement.width, this.leftImageCanvas.nativeElement.height);
    this.pageIndex = i;

    let isNewObject = false;
    if (Array.isArray(this.extractedResultsFull)) {
      if (this.extractedRes.startPageNo <= i && this.extractedRes.endPageNo >= i) {
        this.userSwitchToNextStatement = false;
        // No action needed
      } else {
      isNewObject = true;
      this.userSwitchToNextStatement = true;
      const extractedRes = this.extractedResultsFull.filter((item) => {
        if (item.startPageNo === i) {
          this.header.nativeElement.style.zIndex = 2;
          this.displayStandardFields = true;
          return item;
        } else if (i >= item.startPageNo && i <= item.endPageNo) {
          return item;
        }
      });
      const startPage = Helper.findMaxLTE(i, this.startPageNos);
      this.statementNo = this.startPageNos.indexOf(startPage);
      await this.setValues(false, extractedRes[0]);
      }
    }

    if (path !== 'errorPageNav') {
      if (this.errorPagesConsolidated.includes(this.pageIndex + 1)) {
        this.errorPageClick =
          this.errorPagesConsolidated.indexOf(this.pageIndex + 1) + 1;
      } else {
        this.errorPageClick = 0;
      }
    }
    this.imageBoxEditor.ngOnInit();
    this.imageBoxEditor.closePopover();
    this.boxEditorData = {
      annotations: [],
      imageSrc: null,
      updatedImageSrc: null,
      tableBounds: [],
      showWordBlocks: this.showWordBlocks,
      errors: [],
      fixSuggestions: [] 
    };
    this.rightContext.clearRect(0, 0, this.rightCanvas.nativeElement.width, 5000);

    if (!isNewObject) {
      this.updateCanvasOnbothSides(false);
    } else {
      this.updateCanvasOnbothSides(true);
    }
  }

  async leftCanvas(image, destCanvas: HTMLCanvasElement) {
    this.leftContext = destCanvas.getContext('2d', {
      willReadFrequently: true,
    });
    destCanvas.width = image.width;
    destCanvas.height = image.height;
    this.leftContext.drawImage(image, 0, 0, image.width, image.height);
  }

  replaceMissingDates(data) {
    const extractedRes = data ? data : this.extractedRes;
    let yearWidthAdjustment = 0;
    let yearWidthAdjustmented = false;
    for (let i = 0; i < extractedRes.transactionDetails.length; i++) {
      const cells: TextBlock[] = extractedRes.transactionDetails[i].cells;
      for (let j = 0; j < cells.length; j++) {
        let hasNoDate = false;
        let dateWithoutYear = false;

        if (cells[j].columnIndex === 1 && cells[j].line && !cells[j].line.match(datePatternWithoutYear) && cells[j].line.match(/Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec/)) {
          this.generalErrors.push([
            cells[j].pageIndex + 1,
            cells[j].rowIndex,
            `Invalid Date: ${cells[j].line}`,
          ]);
        }

        if (
          cells[j].columnIndex === 1 && cells[j].line &&
          !cells[j].line.match(datePattern) &&
          !cells[j].line.match(/((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*\d{2}\b/i) &&
          !cells[j].line.match(/\d{4}\b/i) && cells[j].line.match(datePatternWithoutYear)
        ) {
          dateWithoutYear = true;
        } else if (cells[j].columnIndex === 1 && !cells[j].line && cells[j].rowIndex > 1) {
          /**Fix issue where date is auto filled for the bottom closing balance row */
          const cell = cells.find(cell => cell.columnIndex === 2 && cell.rowIndex === cells[j].rowIndex)
          if (!cell || (cell.line && !NO_AUTO_ADD_DATE.has(cell.line.toLocaleUpperCase())))
            // target
            hasNoDate = true;
        }
        if (hasNoDate || dateWithoutYear) {
          // target
          let rowAbove = cells.filter((item) => {
            if (item.rowIndex === cells[j].rowIndex - 1 && item.columnIndex === 1) {
              return item;
            }
          });

          if ((rowAbove.length === 0 ||
             (rowAbove.length > 0 && rowAbove[0].line && rowAbove[0].line.match(/Dat/i))) && i > 0) {
            const prevPageCells = extractedRes.transactionDetails[i - 1].cells;
            let uniqueRowIndex = [
              ...new Set(prevPageCells.map((item) => item.rowIndex)),
            ];
            uniqueRowIndex = [...uniqueRowIndex].sort((a: any, b: any) => a - b);
            rowAbove = prevPageCells.filter((item) => {
              if (
                item.rowIndex === uniqueRowIndex[uniqueRowIndex.length - 1] &&
                item.columnIndex === 1
              ) {
                return item;
              }
            });
          }

          // many rows above were being deleted by the user
          if (rowAbove.length === 0) {
            for (let z = cells[j].rowIndex - 2; z >= 0; z--) {
              if (rowAbove.length > 0) break;
              rowAbove = cells.filter((item) => {
                if (item.rowIndex === z && item.columnIndex === 1) {
                  return item;
                }
              });
            }
          }

          let year = '';
          if (rowAbove.length > 0 && rowAbove[0].wordsAnnotationArray) {
            for (const item of rowAbove[0].wordsAnnotationArray) {
              if (item.description && item.description.match(/(20\d{2})\b/)) {
                year = item.description.match(/(20\d{2})\b/)[0];
              }
            }
            // Oct15
            if (rowAbove[0].line &&
                rowAbove[0].line.match(/((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*\d{2}\b/i)) {
              const target = rowAbove[0].line.match(/((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*\d{2}\b/i)[0];
              year = target.match(/\d{2}\b/)[0];
              year = `20${year}`;
            }
          }

          if (rowAbove.length > 0 && rowAbove[0].line &&
              (rowAbove[0].line.match(datePattern) ||
              rowAbove[0].line.match(/(20\d{2})\b/) ||
              rowAbove[0].line.match(/((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*\d{2}\b/i))
          ) {
            const newWordsAnnotationArray = [];
            if (hasNoDate) {
              const wordsAnnotationArray = rowAbove[0].wordsAnnotationArray;
              for (let z = 0; z < wordsAnnotationArray.length; z++) {
                const temp = wordsAnnotationArray[z];
                const wordHeight = temp.boundingPoly.vertices[2].y - temp.boundingPoly.vertices[1].y;
                const topY = cells[j].boundingPoly.vertices[0].y + 1;
                const boundingPoly = {
                  vertices: [
                    { x: temp.boundingPoly.vertices[0].x, y: topY },
                    { x: temp.boundingPoly.vertices[1].x, y: topY },
                    { x: temp.boundingPoly.vertices[2].x, y: topY + wordHeight },
                    { x: temp.boundingPoly.vertices[3].x, y: topY + wordHeight },
                  ],
                };
                const block = {
                  boundingPoly,
                  description: temp.description,
                  id: temp.id,
                  isSubstituted: true,
                };
                newWordsAnnotationArray.push(block);
              }
            }
            let line = '';
            const words = [];
            // check if year fits in otherwise adjust cell/ word annotations
            if (cells[j].wordsAnnotationArray && cells[j].wordsAnnotationArray.length > 0 && !yearWidthAdjustmented) {
              const remainingSpace = cells[j].boundingPoly.vertices[1].x - cells[j].wordsAnnotationArray[
                  cells[j].wordsAnnotationArray.length - 1].boundingPoly.vertices[1].x;
              yearWidthAdjustment = yearWidth - remainingSpace;
              if (yearWidthAdjustment < 3) yearWidthAdjustment = 0;
              yearWidthAdjustmented = true;
            }
            // if (this.extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[0].x - yearWidthAdjustment < 10)
            //   yearWidthAdjustment = 0;
            if (dateWithoutYear && year) {
              const wordsAnnotationArray = cells[j].wordsAnnotationArray;
              for (let z = 0; z < wordsAnnotationArray.length; z++) {
                line = line + ' ' + wordsAnnotationArray[z].description;
                words.push(wordsAnnotationArray[z].description);
                let boundingPoly = {
                  vertices: [
                    {
                      x: wordsAnnotationArray[z].boundingPoly.vertices[0].x - yearWidthAdjustment,
                      y: wordsAnnotationArray[z].boundingPoly.vertices[0].y,
                    },
                    {
                      x: wordsAnnotationArray[z].boundingPoly.vertices[1].x - yearWidthAdjustment,
                      y: wordsAnnotationArray[z].boundingPoly.vertices[1].y,
                    },
                    {
                      x: wordsAnnotationArray[z].boundingPoly.vertices[2].x - yearWidthAdjustment,
                      y: wordsAnnotationArray[z].boundingPoly.vertices[2].y,
                    },
                    {
                      x: wordsAnnotationArray[z].boundingPoly.vertices[3].x - yearWidthAdjustment,
                      y: wordsAnnotationArray[z].boundingPoly.vertices[3].y,
                    },
                  ],
                };
                let block = {
                  boundingPoly,
                  description: wordsAnnotationArray[z].description,
                  id: wordsAnnotationArray[z].id,
                  isSubstituted: false,
                  adjustedDateX: true,
                  yearWidthAdjustment: yearWidthAdjustment,
                };
                newWordsAnnotationArray.push(block);
                if (z === wordsAnnotationArray.length - 1) {
                  boundingPoly = {
                    vertices: [
                      {
                        x: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[1].x + 1,
                        y: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[0].y,
                      },
                      {
                        x: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[1].x + 27,
                        y: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[1].y,
                      },
                      {
                        x: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[1].x + 27,
                        y: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[2].y,
                      },
                      {
                        x: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[1].x + 1,
                        y: newWordsAnnotationArray[newWordsAnnotationArray.length - 1].boundingPoly.vertices[3].y,
                      },
                    ],
                  };
                  line = line + ' ' + year;
                  words.push(year);
                  block = {
                    boundingPoly,
                    description: year,
                    id: wordsAnnotationArray[z].id + 'addedYear',
                    isSubstituted: true,
                    adjustedDateX: true,
                    yearWidthAdjustment,
                  };
                  newWordsAnnotationArray.push(block);
                }
              }
            }
            if (hasNoDate) {
              extractedRes.transactionDetails[i].cells[j].line = rowAbove[0].line;
              extractedRes.transactionDetails[i].cells[j].words = rowAbove[0].words;
            } else if (dateWithoutYear && year) {
              extractedRes.transactionDetails[i].cells[j].line = line;
              extractedRes.transactionDetails[i].cells[j].words = words;
            }

            extractedRes.transactionDetails[i].cells[j].adjustedDateX = true;
            extractedRes.transactionDetails[i].cells[j].yearWidthAdjustment = yearWidthAdjustment;
            extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[0].x =
            extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[0].x - yearWidthAdjustment;
            extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[3].x =
            extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[3].x - yearWidthAdjustment;
            const id = rowAbove[0].id;
            extractedRes.transactionDetails[i].cells =
              extractedRes.transactionDetails[i].cells.filter((cell) => {
                if (cell.id === id) {
                  cell.boundingPoly.vertices[0].x =
                    extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[0].x;
                  cell.boundingPoly.vertices[3].x =
                    extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[3].x;
                  cell.adjustedDateX = true;
                  cell.yearWidthAdjustment = yearWidthAdjustment;
                  cell.hasSubstitutedWordsAnnotationArray = true;
                } else if (
                  cell.columnIndex === 1 &&
                  cell.line &&
                  cell.line.match(/Dat/i)
                ) {
                  cell.boundingPoly.vertices[0].x =
                    extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[0].x;
                  cell.boundingPoly.vertices[3].x =
                    extractedRes.transactionDetails[i].cells[j].boundingPoly.vertices[3].x;
                  cell.adjustedDateX = true;
                  cell.yearWidthAdjustment = yearWidthAdjustment;
                  cell.hasSubstitutedWordsAnnotationArray = true;
                }
                return cell;
              });
            extractedRes.transactionDetails[i].cells[j].wordsAnnotationArray = newWordsAnnotationArray;
            extractedRes.transactionDetails[i].cells[j].hasSubstitutedWordsAnnotationArray = true;
          }
        }
      }
    }
  }

  revertSubstitutedValues() {
    for (let i = 0; i < this.extractedRes.transactionDetails.length; i++) {
      const cells = this.extractedRes.transactionDetails[i].cells;
      for (let j = 0; j < cells.length; j++) {
        if (cells[j].hasSubstitutedWordsAnnotationArray) {
          // target
          const temp = cells[j];
          if (cells[j].adjustedDateX && temp.yearWidthAdjustment) {
            temp.adjustedDateX = false;
            temp.boundingPoly.vertices[0].x = temp.boundingPoly.vertices[0].x + temp.yearWidthAdjustment;
            temp.boundingPoly.vertices[3].x = temp.boundingPoly.vertices[0].x + temp.yearWidthAdjustment;
          }
          const newWordsAnnotationArray = [];
          let newLine = '';
          const newWords = [];
          for (const item of temp.wordsAnnotationArray) {
            if (!item.isSubstituted) {
              if (item.adjustedDateX && temp.yearWidthAdjustment) {
                item.boundingPoly.vertices[0].x = item.boundingPoly.vertices[0].x + temp.yearWidthAdjustment;
                item.boundingPoly.vertices[1].x = item.boundingPoly.vertices[1].x + temp.yearWidthAdjustment;
                item.boundingPoly.vertices[2].x = item.boundingPoly.vertices[2].x + temp.yearWidthAdjustment;
                item.boundingPoly.vertices[3].x = item.boundingPoly.vertices[3].x + temp.yearWidthAdjustment;
              }
              newWordsAnnotationArray.push(item);
              newLine = newLine + ' ' + item.description;
              newWords.push(item.description);
            }
          }
          temp.wordsAnnotationArray = newWordsAnnotationArray;
          temp.line = newLine.trim();
          temp.words = newWords;
          temp.hasSubstitutedWordsAnnotationArray = false;
          this.extractedRes.transactionDetails[i].cells[j] = temp;
        }
      }
    }
  }

  resizeResolution(extractedRes, newWidth, newHeight, revert) {
    const data = [];
    let changeWidthHeightOrBoth;

    if (newWidth > 0 && newHeight > 0) {
      changeWidthHeightOrBoth = 'B';
    } else if (newWidth > 0) {
      changeWidthHeightOrBoth = 'W';
    } else if (newHeight > 0) {
      changeWidthHeightOrBoth = 'H';
    } else {
      return extractedRes;
    }

    if ((extractedRes.transactionDetails && extractedRes.transactionDetails.length) ||
        (extractedRes.allTables && extractedRes.allTables.length)
    ) {
      const target = this.fetchAllTables ? extractedRes.allTables : extractedRes.transactionDetails;
      for (const item of target) {
        if (item.resizedTextAnnotationsResolution || item.resizedTxtAnnReslTemporarly) {
          data.push(item);
          continue;
        }
        const modifier = { x: 1, y: 1 }; // a modifer of 1 is no change to the coordinate.
        const bounds = this.getWholeTextBound(this.pageBoundingPoly[this.pageIndex]);

        // calculate the new modifier value for each page:
        if (changeWidthHeightOrBoth === 'W') {
          modifier.x = revert ? bounds.width / newWidth : newWidth / bounds.width;
          modifier.y = modifier.x; // modify both x and y by same ammount to preserve aspect ratio
        } else if (changeWidthHeightOrBoth === 'H') {
          modifier.y = revert ? bounds.height / newHeight : newHeight / bounds.height;
          modifier.x = modifier.y; // modify both x and y by same ammount to preserve aspect ratio
        } else if (changeWidthHeightOrBoth === 'B') {
          modifier.x = revert ? bounds.width / newWidth : newWidth / bounds.width;
          modifier.y = revert ? bounds.height / newHeight : newHeight / bounds.height;
        }

        const updatedCells = item.cells.map(cell => {
          const updatedCell = { ...cell };
  
          for (let k = 0; k < 4; k++) {
            const vertex = updatedCell.boundingPoly.vertices[k];
            vertex.x *= modifier.x;
            vertex.y *= modifier.y;
          }
  
          updatedCell.wordsAnnotationArray.forEach(word => {
            for (let k = 0; k < 4; k++) {
              const vertex = word.boundingPoly.vertices[k];
              vertex.x *= modifier.x;
              vertex.y *= modifier.y;
            }
          });
  
          return updatedCell;
        });

        item.cells = updatedCells;
        item.resizedTxtAnnReslTemporarly = true;
        data.push(item);
      }
      if (this.fetchAllTables) {
        extractedRes.allTables = data;
      } else {
        extractedRes.transactionDetails = data;
      }
    }
    return extractedRes;
  }

  resizeResolutionV2(
    wordBlocksArray,
    newWidth,
    newHeight,
    revert,
  ) {
    const wordBlocksArrayResized = [];
    let changeWidthHeightOrBoth;
    if (newWidth > 0 && newHeight > 0) {
      changeWidthHeightOrBoth = 'B';
    } else if (newWidth > 0) {
      changeWidthHeightOrBoth = 'W';
    } else if (newHeight > 0) {
      changeWidthHeightOrBoth = 'H';
    } else return;
    for (let i = 0; i < wordBlocksArray.length; i++) {
      const data = [];
      const modifier = { x: 1, y: 1 }; // a modifer of 1 is no change to the coordinate.
      const bounds = this.getWholeTextBound(this.pageBoundingPoly[this.pageIndex]);
      // calculate the new modifier value for each page:
      if (changeWidthHeightOrBoth === 'W') {
        modifier.x = revert ? bounds.width / newWidth : newWidth / bounds.width;
        modifier.y = modifier.x; // modify both x and y by same ammount to preserve aspect ratio
      } else if (changeWidthHeightOrBoth === 'H') {
        modifier.y = revert ? bounds.height / newHeight : newHeight / bounds.height;
        modifier.x = modifier.y; // modify both x and y by same ammount to preserve aspect ratio
      } else if (changeWidthHeightOrBoth === 'B') {
        modifier.x = revert ? bounds.width / newWidth : newWidth / bounds.width;
        modifier.y = revert ? bounds.height / newHeight : newHeight / bounds.height;
      }

      for (let j = 0; j < wordBlocksArray[i].length; j++) {
        for (let k = 0; k < 4; k++) {
          const vertex = wordBlocksArray[i][j].boundingPoly.vertices[k];
          vertex.x = vertex.x * modifier.x;
          vertex.y = vertex.y * modifier.y;
        }

        wordBlocksArray[i][j].pageIndex = i;
        wordBlocksArray[i][j].wordBlock = true;
        data.push(wordBlocksArray[i][j]);
      }
      wordBlocksArrayResized.push(data);
    }
    return wordBlocksArrayResized;
  }

  getWholeTextBound(pageBoundingPoly) {
    const bounds = { xMin: null, xMax: null, yMin: null, yMax: null };

    bounds.xMin = pageBoundingPoly[0].x;
    bounds.xMax = pageBoundingPoly[1].x;
    bounds.yMin = pageBoundingPoly[0].y;
    bounds.yMax = pageBoundingPoly[2].y;
    if (bounds.yMin === undefined) bounds.yMin = 0;
    if (bounds.xMin === undefined) bounds.xMin = 0;

    const width = bounds.xMax - bounds.xMin;
    const height = bounds.yMax - bounds.yMin;
    return Object.assign(Object.assign({}, bounds), {
      width,
      height,
      aspectRatio: height / width,
    });
  }

  async drawCanvas(reinit = false, isInitialLoading = false) {
    let fixSuggestionsOnCurrentPage = [];
    for (let item of this.fixSuggestions) {
      if (item.pageIndex === this.pageIndex) {
        fixSuggestionsOnCurrentPage.push(item);
      }
    }

    if (fixSuggestionsOnCurrentPage.length > 0) {
      this.lineDraw = true;
    } else {
      this.lineDraw = false;
    }
    await this.validateAllPages(reinit);
    if (this.generalErrors.length > 0 && !this.splitCombinedColumnsCheck) {
      this.splitCombinedColumnsCheck = true;
      this.generalErrors = [];
      this.errorPagesConsolidated = [];
      this.balanceCheckErrorPages = [];
      this.errorPages = [];
      const res = await Helper.splitCombinedColumns(this.extractedRes.transactionDetails);
      if (res.fixApplied) {
        await this.save();
        await this.validateAllPages(reinit);
        await this.injectToHeaderToolbar();
      } else {
        await this.validateAllPages(reinit);
        await this.injectToHeaderToolbar();
      }
    }
    if (this.generalErrors.length > 0 && ((!reinit && this.userSwitchToNextStatement) || (!reinit && isInitialLoading))) {
      this.dialogService
        .open(DialogComponent, {
          context: {
            body: '!!! Fix all highlighted errors for validation check to continue. !!!',
            header: 'Table Error',
            dialogType: 'info'
          },
          closeOnBackdropClick: false,
        })
    }
    if (this.errorPagesConsolidated.length > 0 || this.generalErrors.length > 0) {
      this.revertSubstitutedValues();
    } else if (this.errorPagesConsolidated.length === 0 && this.generalErrors.length === 0) {
      this.replaceMissingDates(this.extractedRes);
    }
    const validationErrors = await this.validate(reinit, isInitialLoading);
    this.drawInit = false;

    this.rightCanvas.nativeElement.width = standardCanvasWidth;
    this.rightCanvas.nativeElement.height = standardCanvasHeight;
    this.rightContext = this.rightCanvas.nativeElement.getContext('2d', {
      willReadFrequently: true,
    });
    const annotations = [];
    this.tableBounds = [];
    const startPageNo = this.extractedRes.startPageNo ? this.extractedRes.startPageNo : 0;
    let wordBlocks = this.showWordBlocks ? this.wordBlocks[this.pageIndex - startPageNo] : []; // 
    // if (this.extractedRes.transactionDetails || this.extractedRes.allTables) {
      let target = this.fetchAllTables
        ? this.extractedRes.allTables
        : this.extractedRes.transactionDetails;
      if (!target) target = [];
      const data = target.filter((item) => {
        if (item.pageIndex === this.pageIndex) {
          return item;
        }
      });

      const errorRowsInCurrentPage = [];
      this.generalErrors.filter((item) => {
        if (item[0] === this.pageIndex + 1) {
          errorRowsInCurrentPage.push(item[1]);
        }
      });


      for (let j = 0; j < data.length; j++) {
        const temp = data[j];
        let yTopArr = [];
        let yBottomArr = [];
        let xLeftArr = [];
        let xRightArr = [];
        for (const cell of temp.cells) {
          yTopArr.push(cell.boundingPoly.vertices[0].y);
          yBottomArr.push(cell.boundingPoly.vertices[3].y);
          xLeftArr.push(cell.boundingPoly.vertices[0].x);
          xRightArr.push(cell.boundingPoly.vertices[1].x);
          this.rightContext.font = 'bold 15px Times New Roman';
          // this.rightContext.font = 'Times New Roman';
          // this.rightContext.fillStyle = cell.error ? 'blue' : 'black';
          for (const item of cell.wordsAnnotationArray) {
            this.rightContext.fillStyle = errorRowsInCurrentPage.includes(cell.rowIndex)
              ? 'red'
              : 'black';
            if (!item.boundingPoly) continue;
            this.rightContext.fillText(
              item.description ? item.description : '',
              item.boundingPoly.vertices[0].x,
              item.boundingPoly.vertices[0].y + rightCanvasOfstY,
              item.boundingPoly.vertices[1].x - item.boundingPoly.vertices[0].x);
          }
          annotations.push({
            boundingPoly: cell.boundingPoly,
            description: cell.line ? cell.line : '',
            cell,
            tableIndex: j,
            error: errorRowsInCurrentPage.includes(cell.rowIndex) ? true : false
          });
        }

        yTopArr = [...yTopArr].sort((a, b) => a - b);
        yBottomArr = [...yBottomArr].sort((a, b) => a - b);
        xLeftArr = [...xLeftArr].sort((a, b) => a - b);
        xRightArr = [...xRightArr].sort((a, b) => a - b);
        this.tableBounds.push({ yTopArr, yBottomArr, xLeftArr, xRightArr });
        wordBlocks = wordBlocks.filter((item) => {
          if (
            item.boundingPoly.vertices[0].y > yTopArr[0] &&
            item.boundingPoly.vertices[2].y < yBottomArr[yBottomArr.length - 1] &&
            item.boundingPoly.vertices[0].x > xLeftArr[0] &&
            item.boundingPoly.vertices[1].x < xRightArr[xRightArr.length - 1]
          ) {
            // table
          } else {
            return item;
          }
        });
      }

      for (const item of wordBlocks) {
        this.rightContext.fillStyle = 'blue';

        this.rightContext.fillText(
          item.description ? item.description : '',
          item.boundingPoly.vertices[0].x,
          item.boundingPoly.vertices[0].y + rightCanvasOfstY,
          item.boundingPoly.vertices[1].x - item.boundingPoly.vertices[0].x);

        annotations.push({
          boundingPoly: item.boundingPoly,
          description: item.description,
          pageIndex: this.pageIndex,
          isWordBlock: true,
        });
      }
    // }

    const canvasUrl = this.rightCanvas.nativeElement.toDataURL();
    this.rightContext.clearRect(
      0,
      0,
      this.rightCanvas.nativeElement.width,
      this.rightCanvas.nativeElement.height);
    if (reinit) {
      this.boxEditorData = {
        annotations: annotations,
        imageSrc: null,
        updatedImageSrc: canvasUrl,
        tableBounds: this.tableBounds,
        showWordBlocks: this.showWordBlocks,
        errors: validationErrors ? validationErrors : [],
        fixSuggestions: fixSuggestionsOnCurrentPage
      };
    } else {
      this.boxEditorData = {
        annotations: annotations,
        imageSrc: canvasUrl,
        updatedImageSrc: null,
        tableBounds: this.tableBounds,
        showWordBlocks: this.showWordBlocks,
        errors: validationErrors ? validationErrors : [],
        fixSuggestions: fixSuggestionsOnCurrentPage
      };
    }

    this.drawInit = true;
    this.injectToHeaderToolbar();
  }

  injectToHeaderToolbar() {
    const data = {
      loading: this.loading,
      displayStandardFields: this.fetchAllTables
        ? false
        : this.displayStandardFields,
      pageIndex: this.pageIndex,
      noOfPages: 1,
      errorPagesConsolidated: this.errorPagesConsolidated,
      errorPageClick: this.errorPageClick,
      statusColor: this.statusColor,
      status: this.status,
      changes: this.changes,
      fetchAllTables: this.fetchAllTables,
      jobId: this.jobId,
      startPageNos: this.startPageNos,
      statementNo: this.statementNo,
      projectName: this.projectName,
      skewFactorX: this.skewFactorX,
      skewFactorY: this.skewFactorY,
      lineDraw: this.lineDraw
    };

    this.jobService.setValues(data);
  }

  async boxEditorRes(res) {
    let updated = false;

    let tables = this.fetchAllTables
      ? this.extractedRes.allTables : this.extractedRes.transactionDetails;
    let tablesPreserved = this.fetchAllTables
      ? this.extractedResPreserved.allTables : this.extractedResPreserved.transactionDetails;

    if (!tables) {
      tables = [];
      tablesPreserved = [];
    }

    const targetPage = tables.filter((item) => {
      return item.pageIndex === this.pageIndex;
    });
    const targetPagePreserved = tablesPreserved.filter((item) => {
      return item.pageIndex === this.pageIndex;
    });

    if (res.eventType === 'reinit') {
      this.fixSuggestions = this.fixSuggestions.filter((item) => {
        if (item.pageIndex !== this.pageIndex) {
          return item;
        }
      });
      this.drawCanvas(true);
    } else if (res.eventType === 'update') {
      for (let i = 0; i < targetPage.length; i++) {
        const totalNoOfCells = targetPage[i].cells.length;
        const cellsWithText = [];
        targetPagePreserved[i].cells.filter((item) => {
          if (
            item.wordsAnnotationArray.length > 0 &&
            item.wordsAnnotationArray[0].description &&
            item.wordsAnnotationArray[0].description.length > 3
          ) {
            cellsWithText.push(item);
          }
        });
        const word = cellsWithText[0].wordsAnnotationArray[0].description;
        const boundingPoly = cellsWithText[0].wordsAnnotationArray[0].boundingPoly;
        const charWidth = (boundingPoly.vertices[1].x - boundingPoly.vertices[0].x) / word.length;
        const height = boundingPoly.vertices[2].y - boundingPoly.vertices[0].y;
        for (let j = 0; j < totalNoOfCells; j++) {
          if (targetPage[i].cells[j].id === res.cell.id) {
            const array = res.newValue ? res.newValue.split(' ') : [''];

            let prevWordsAnnotatonArray = [];
            if (targetPage[i].cells[j].wasEmptyWordsAnnotationArray) {
              targetPagePreserved[i].cells[j].wordsAnnotationArray = [];
            }
            let wasEmptyWordsAnnotationArray = false;

            let newWordsAnnotatonArray = [];
            for (let z = 0; z < array.length; z++) {
              newWordsAnnotatonArray.push({ description: array[z] });
            }

            if (targetPagePreserved[i].cells[j].wordsAnnotationArray.length === 0 || (targetPagePreserved[i].cells[j].wordsAnnotationArray.length === 1 &&
              !targetPagePreserved[i].cells[j].wordsAnnotationArray[0].description)) {
                wasEmptyWordsAnnotationArray = true;
                for (let z = newWordsAnnotatonArray.length - 1; z >= 0; z--) {
                  const adjustment = newWordsAnnotatonArray[z].description.length * charWidth;
                  newWordsAnnotatonArray[z].boundingPoly = {};
                  if (z === newWordsAnnotatonArray.length - 1) {
                    newWordsAnnotatonArray[z].boundingPoly.vertices = [
                      {
                        x: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].x - 2 - adjustment,
                        y: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].y + 2,
                      },
                      {
                        x: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].x - 2,
                        y: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].y + 2,
                      },
                      {
                        x: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].x - 2,
                        y: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].y + 2 + height,
                      },
                      {
                        x: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].x - 2 - adjustment,
                        y: targetPagePreserved[i].cells[j].boundingPoly.vertices[1].y + 2 + height,
                      },
                    ];
                  } else {
                    newWordsAnnotatonArray[z].boundingPoly.vertices = [
                      {
                        x: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[0].x - 2 - adjustment,
                        y: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[1].y + 2,
                      },
                      {
                        x: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[0].x - 2,
                        y: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[1].y + 2,
                      },
                      {
                        x: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[2].x - 2,
                        y: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[1].y + 2 + height,
                      },
                      {
                        x: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[2].x - 2 - adjustment,
                        y: newWordsAnnotatonArray[z + 1].boundingPoly.vertices[1].y + 2 + height,
                      },
                    ];
                  }
                }
                if (newWordsAnnotatonArray.length === 1 && targetPagePreserved[i].cells[j].wordsAnnotationArray.length === 0) {
                  newWordsAnnotatonArray = Helper.alignTextToMiddle(newWordsAnnotatonArray, targetPagePreserved[i].cells[j].boundingPoly);
                }
            } else {
              prevWordsAnnotatonArray = targetPage[i].cells[j].wordsAnnotationArray;
              if (prevWordsAnnotatonArray.length === 1 && newWordsAnnotatonArray.length === 1) {
                if (prevWordsAnnotatonArray[0].description.length === newWordsAnnotatonArray[0].description.length) {
                  newWordsAnnotatonArray[0].boundingPoly = prevWordsAnnotatonArray[0].boundingPoly;
                } else {
                  const leftMargin = prevWordsAnnotatonArray[0].boundingPoly.vertices[0].x - targetPage[i].cells[j].boundingPoly.vertices[0].x;
                  const rightMargin = targetPage[i].cells[j].boundingPoly.vertices[1].x - prevWordsAnnotatonArray[0].boundingPoly.vertices[1].x;
                  const adjustmentForNewText = res.newValue.length * charWidth;
                  const cellWidth = targetPage[i].cells[j].boundingPoly.vertices[1].x - targetPage[i].cells[j].boundingPoly.vertices[0].x;
                  if (adjustmentForNewText > cellWidth) {
                    this.dialogService
                      .open(DialogComponent, {
                        context: {
                          body: '!!! Text exceeds cell width !!!',
                          header: 'Error',
                          dialogType: 'info'
                        },
                        closeOnBackdropClick: false,
                      })
                    return;
                  }
                  const adjustment = newWordsAnnotatonArray[0].description.length * charWidth;
                  newWordsAnnotatonArray[0].boundingPoly = prevWordsAnnotatonArray[0].boundingPoly;
                  const remainingWidth =
                    adjustment - (newWordsAnnotatonArray[0].boundingPoly.vertices[1].x - newWordsAnnotatonArray[0].boundingPoly.vertices[0].x);
                  if (rightMargin < leftMargin) {
                    if (remainingWidth > 0) {
                      newWordsAnnotatonArray[0].boundingPoly.vertices[0].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[0].x - remainingWidth;
                      newWordsAnnotatonArray[0].boundingPoly.vertices[3].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[3].x - remainingWidth;
                      newWordsAnnotatonArray[0].boundingPoly.vertices[1].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[0].x + adjustment;
                      newWordsAnnotatonArray[0].boundingPoly.vertices[2].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[3].x + adjustment;
                    } else {
                      newWordsAnnotatonArray[0].boundingPoly.vertices[1].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[0].x + adjustment;
                      newWordsAnnotatonArray[0].boundingPoly.vertices[2].x =
                        newWordsAnnotatonArray[0].boundingPoly.vertices[3].x + adjustment;
                    }
                  }
                }
              } else {
                if (
                  targetPage[i].cells[j].line.length === res.newValue.length
                ) {
                  for (let a = 0; a < prevWordsAnnotatonArray.length; a++) {
                    newWordsAnnotatonArray[a].boundingPoly = prevWordsAnnotatonArray[a].boundingPoly;
                  }
                } else {

                  let adjustment = res.newValue.length * charWidth;
                  const cellWidth =
                    targetPage[i].cells[j].boundingPoly.vertices[1].x -
                    targetPage[i].cells[j].boundingPoly.vertices[0].x;
                  if (adjustment > cellWidth) {
                    this.dialogService
                    .open(DialogComponent, {
                      context: {
                        body: '!!! Text exceeds cell width !!!',
                        header: 'Error',
                        dialogType: 'info'
                      },
                      closeOnBackdropClick: false,
                    })
                    return;
                  }
                  let changeIdentified = false;
                  for (let i = 0; i < prevWordsAnnotatonArray.length; i++) {
                    // if (rightMargin < leftMargin) {
                    //   // fix
                    // } else {
                      if (
                        prevWordsAnnotatonArray[i] &&
                        newWordsAnnotatonArray[i] &&
                        prevWordsAnnotatonArray[i].description !== newWordsAnnotatonArray[i].description &&
                        !changeIdentified
                      ) {
                        changeIdentified = true;
                        adjustment = newWordsAnnotatonArray[i].description.length * charWidth;
                        prevWordsAnnotatonArray[i].boundingPoly.vertices[1].x = prevWordsAnnotatonArray[i].boundingPoly.vertices[0].x + adjustment;
                        prevWordsAnnotatonArray[i].boundingPoly.vertices[2].x = prevWordsAnnotatonArray[i].boundingPoly.vertices[3].x + adjustment;
                        newWordsAnnotatonArray[i].boundingPoly = prevWordsAnnotatonArray[i].boundingPoly;
                        if (
                          newWordsAnnotatonArray.length > prevWordsAnnotatonArray.length
                        ) {
                          // if new word added to mid
                          while (i < newWordsAnnotatonArray.length - 1) {
                            adjustment = newWordsAnnotatonArray[i + 1].description.length * charWidth;
                            const topY = newWordsAnnotatonArray[i].boundingPoly.vertices[1].y;
                            const bottomY = newWordsAnnotatonArray[i].boundingPoly.vertices[2].y;
                            const boundingPoly = {
                              vertices: [
                                { x: 0, y: topY },
                                { x: 0, y: topY },
                                { x: 0, y: bottomY },
                                { x: 0, y: bottomY },
                              ],
                            };
                            boundingPoly.vertices[0].x = newWordsAnnotatonArray[i].boundingPoly.vertices[1].x + 5;
                            boundingPoly.vertices[3].x = newWordsAnnotatonArray[i].boundingPoly.vertices[2].x + 5;
                            boundingPoly.vertices[1].x = boundingPoly.vertices[0].x + adjustment;
                            boundingPoly.vertices[2].x = boundingPoly.vertices[3].x + adjustment;
                            newWordsAnnotatonArray[i + 1].boundingPoly = boundingPoly;
                            i++;
                          }
                        }
                        continue;
                      }
                      if (!changeIdentified) {                     
                        if (newWordsAnnotatonArray[i]) newWordsAnnotatonArray[i].boundingPoly = prevWordsAnnotatonArray[i].boundingPoly;
                        if (
                          i === prevWordsAnnotatonArray.length - 1 &&
                          newWordsAnnotatonArray.length > prevWordsAnnotatonArray.length
                        ) {
                          // end of line
                          while (i < newWordsAnnotatonArray.length - 1) {
                            adjustment = newWordsAnnotatonArray[i + 1].description.length * charWidth;
                            const topY = newWordsAnnotatonArray[i].boundingPoly.vertices[1].y;
                            const bottomY = newWordsAnnotatonArray[i].boundingPoly.vertices[2].y;
                            const boundingPoly = {
                              vertices: [
                                { x: 0, y: topY },
                                { x: 0, y: topY },
                                { x: 0, y: bottomY },
                                { x: 0, y: bottomY },
                              ],
                            };
                            boundingPoly.vertices[0].x = newWordsAnnotatonArray[i].boundingPoly.vertices[1].x + 5;
                            boundingPoly.vertices[3].x = newWordsAnnotatonArray[i].boundingPoly.vertices[2].x + 5;
                            boundingPoly.vertices[1].x = boundingPoly.vertices[0].x + adjustment;
                            boundingPoly.vertices[2].x = boundingPoly.vertices[3].x + adjustment;
                            newWordsAnnotatonArray[i + 1].boundingPoly = boundingPoly;
                            i++;
                          }
                        }
                        continue;
                      }
                      const boundingPoly = prevWordsAnnotatonArray[i].boundingPoly;
                      if (boundingPoly && newWordsAnnotatonArray[i - 1]) {
                        boundingPoly.vertices[0].x = newWordsAnnotatonArray[i - 1].boundingPoly.vertices[1].x + 5;
                        boundingPoly.vertices[3].x = newWordsAnnotatonArray[i - 1].boundingPoly.vertices[2].x + 5;
                        boundingPoly.vertices[1].x = boundingPoly.vertices[0].x + adjustment;
                        boundingPoly.vertices[2].x = boundingPoly.vertices[3].x + adjustment;
                      }
                      if (newWordsAnnotatonArray[i]) {
                        newWordsAnnotatonArray[i].boundingPoly = boundingPoly;
                      }
                    // }
                  }
                }
              }
            }

            targetPage[i].cells[j].wordsAnnotationArray = newWordsAnnotatonArray;
            targetPage[i].cells[j].wasEmptyWordsAnnotationArray = wasEmptyWordsAnnotationArray;
            targetPage[i].cells[j].line = res.newValue;

            j = targetPage[i].cells.length + 1;
            i = targetPage.length + 1;
          }
        }
      }
      updated = true;
    } else if (res.eventType === 'mouseover') {
      if (this.selectedBox) {
        this.leftContext.drawImage(this.leftImage, 0, 0, this.leftImage.width, this.leftImage.height);
      }
      const vertices: any = res.rectPos;

      const widthPercentage = (vertices[0].x / this.rightCanvas.nativeElement.width) * 100;
      const leftTopX = (this.leftImageCanvas.nativeElement.width * widthPercentage) / 100;
      const heightPercentage = (vertices[0].y / this.rightCanvas.nativeElement.height) * 100;
      const leftTopY = (this.leftImageCanvas.nativeElement.height * heightPercentage) / 100;
      const temp1 = (vertices[1].x / this.rightCanvas.nativeElement.width) * 100;
      const rightTopX = (this.leftImageCanvas.nativeElement.width * temp1) / 100;
      const temp2 = (vertices[2].y / this.rightCanvas.nativeElement.height) * 100;
      const rightBottomY = (this.leftImageCanvas.nativeElement.height * temp2) / 100;
      const strokeWidth = rightTopX - leftTopX;
      const strokeHeight = rightBottomY - leftTopY;

      this.selectedBox = {
        leftTopX,
        leftTopY,
        strokeWidth,
        strokeHeight,
        vertices,
      };

      this.leftContext.beginPath();
      this.leftContext.lineWidth = 4;
      this.leftContext.strokeStyle = 'blue';
      this.leftContext.rect(leftTopX, leftTopY + 7, strokeWidth, strokeHeight);
      this.leftContext.stroke();

      this.leftContext.beginPath();
      this.leftContext.lineWidth = 3;
      this.leftContext.strokeStyle = 'black';
      this.leftContext.rect(150, leftTopY + strokeHeight + 7, this.leftImageCanvas.nativeElement.width - 200, 0);
      this.leftContext.stroke();
    } else if (res.eventType === 'dragend') {
      let dragUpDownFix = false;
      if (res.selectedAnnotation.isWordBlock && targetPage.length > 0) {
        const cells = targetPage[0].cells;
        const startPageNo = this.extractedRes.startPageNo ? this.extractedRes.startPageNo : 0;
        const wordBlocks = this.showWordBlocks ? this.wordBlocks[this.pageIndex - startPageNo] : [];
    
        // Find min and max rowIndex
        let minRowIndex = Number.MAX_SAFE_INTEGER;
        let maxRowIndex = Number.MIN_SAFE_INTEGER;
        cells.forEach(item => {
            minRowIndex = Math.min(minRowIndex, item.rowIndex);
            maxRowIndex = Math.max(maxRowIndex, item.rowIndex);
        });
    
        const blocksWithMinRowIndex = cells.filter(item => item.rowIndex === minRowIndex);
        const blocksWithMaxRowIndex = cells.filter(item => item.rowIndex === maxRowIndex);
    
        const { vertices } = res.selectedAnnotation.boundingPoly;
        const [vertex0, vertex3] = vertices;
    
        if (vertex3.y < blocksWithMinRowIndex[0].boundingPoly.vertices[0].y) { // User tries to add a row on top
            const wordBlockBelowSelectedArea = wordBlocks.filter(item => item.boundingPoly.vertices[0].y > vertex0.y - 5 && item.boundingPoly.vertices[0].y < blocksWithMinRowIndex[0].boundingPoly.vertices[0].y);
    
            const newRow = blocksWithMinRowIndex.map(cell => {
                const temp = deepCopy(cell);
                const filteredWordBlocks = wordBlockBelowSelectedArea.filter(item => cell.boundingPoly.vertices[0].x <= item.boundingPoly.vertices[0].x && cell.boundingPoly.vertices[1].x >= item.boundingPoly.vertices[1].x);
                temp.wordsAnnotationArray = filteredWordBlocks;
                temp.boundingPoly.vertices[0].y = vertex0.y - 5;
                temp.boundingPoly.vertices[1].y = vertex0.y - 5;
                temp.boundingPoly.vertices[2].y = cell.boundingPoly.vertices[1].y;
                temp.boundingPoly.vertices[3].y = cell.boundingPoly.vertices[0].y;
                temp.words = filteredWordBlocks.map(word => word.description);
                temp.line = filteredWordBlocks.map(word => word.description).join(' ');
                return temp;
            });
    
            cells.forEach(cell => cell.rowIndex += 1);
            cells.unshift(...newRow);
            await this.update(targetPage);
        } else if (vertex0.y > blocksWithMaxRowIndex[0].boundingPoly.vertices[0].y) { // User tries to add a row on table bottom
            const wordBlockAbvSelectedArea = wordBlocks.filter(item => item.boundingPoly.vertices[0].y <= vertex0.y + 5 && item.boundingPoly.vertices[0].y > blocksWithMaxRowIndex[0].boundingPoly.vertices[3].y);
            const newRow = blocksWithMaxRowIndex.map(cell => {
                const temp = deepCopy(cell);
                const filteredWordBlocks = wordBlockAbvSelectedArea.filter(item => cell.boundingPoly.vertices[0].x <= item.boundingPoly.vertices[0].x && cell.boundingPoly.vertices[1].x >= item.boundingPoly.vertices[1].x);
                temp.wordsAnnotationArray = filteredWordBlocks;
                temp.boundingPoly.vertices[0].y = cell.boundingPoly.vertices[3].y;
                temp.boundingPoly.vertices[1].y = cell.boundingPoly.vertices[2].y;
                temp.boundingPoly.vertices[2].y = vertex3.y + 5;
                temp.boundingPoly.vertices[3].y = vertex3.y + 5;
                temp.words = filteredWordBlocks.map(word => word.description);
                temp.line = filteredWordBlocks.map(word => word.description).join(' ');
                temp.rowIndex += 1;
                return temp;
            });
    
            cells.push(...newRow);
            await this.update(targetPage);
        }
        return;
      }
      const selectedCell = res.selectedAnnotation.cell;
      let dargedUp = false;
      let dragedDown = false;
      let dragedRight = false;
      let dragedLeft = false;
      const yChange = Math.abs(res.selectedAnnotation.boundingPoly.vertices[0].y - res.rect.attrs.y);
      const xChange = Math.abs(res.selectedAnnotation.boundingPoly.vertices[0].x - res.rect.attrs.x);
      let targetPartOfTable = false;
      let targetPartOfTableIndex;
      if (this.showWordBlocks) {
        const targetNewPos = [
          {
            x: res.selectedAnnotation.boundingPoly.vertices[0].x + xChange,
            y: res.selectedAnnotation.boundingPoly.vertices[0].y + yChange,
          },
          {
            x: res.selectedAnnotation.boundingPoly.vertices[1].x + xChange,
            y: res.selectedAnnotation.boundingPoly.vertices[1].y + yChange,
          },
          {
            x: res.selectedAnnotation.boundingPoly.vertices[2].x + xChange,
            y: res.selectedAnnotation.boundingPoly.vertices[2].y + yChange,
          },
          {
            x: res.selectedAnnotation.boundingPoly.vertices[3].x + xChange,
            y: res.selectedAnnotation.boundingPoly.vertices[3].y + yChange,
          },
        ];
        for (let i = 0; i < this.tableBounds.length; i++) {
          if (
            this.tableBounds[i].xLeftArr[0] <= targetNewPos[0].x &&
            this.tableBounds[i].xRightArr[this.tableBounds[i].xRightArr.length - 1] >= targetNewPos[1].x &&
            this.tableBounds[i].yTopArr[0] <= targetNewPos[0].y &&
            this.tableBounds[i].yBottomArr[this.tableBounds[i].yBottomArr.length - 1] >= targetNewPos[3].y
          ) {
            targetPartOfTableIndex = i;
            targetPartOfTable = true;
            break;
          }
        }
        if (targetPartOfTable === false) {
          // create new table
          const wordBlockPartOfTable = this.wordBlocks[this.pageIndex].filter(
            (item) => {
              if (
                item.boundingPoly.vertices[0].x >= res.selectedAnnotation.boundingPoly.vertices[0].x &&
                item.boundingPoly.vertices[1].x <= targetNewPos[0].x &&
                item.boundingPoly.vertices[0].y >= res.selectedAnnotation.boundingPoly.vertices[0].y - 2 &&
                item.boundingPoly.vertices[3].y <= targetNewPos[3].y
              ) {
                return item;
              }
            },
          );
          let line = '';
          const words = [];
          for (const el of wordBlockPartOfTable) {
            line = line + ' ' + el.description;
            words.push(el.description);
          }
          const newTable = {
            blockType: 'CELL',
            columnIndex: 1,
            columnSpan: 1,
            rowIndex: 1,
            rowSpan: 1,
            description: '',
            id: uuidv4(),
            line: line,
            wordsAnnotationArray: wordBlockPartOfTable,
            words: words,
            boundingPoly: {
              vertices: [
                {
                  x: res.selectedAnnotation.boundingPoly.vertices[0].x - 5,
                  y: res.selectedAnnotation.boundingPoly.vertices[0].y - 5,
                },
                {
                  x: targetNewPos[0].x + 5,
                  y: res.selectedAnnotation.boundingPoly.vertices[0].y - 5,
                },
                {
                  x: targetNewPos[0].x,
                  y: targetNewPos[2].y + 5,
                },
                {
                  x: res.selectedAnnotation.boundingPoly.vertices[0].x - 5,
                  y: targetNewPos[2].y,
                },
              ],
            },
          };
          if (this.fetchAllTables) {
            this.extractedRes.allTables.push({
              cells: [newTable],
              pageIndex: this.pageIndex,
            });
            this.showWordBlocks = false;
            await this.drawCanvas(true);
            this.save();
          } else {
            if (!this.extractedRes.transactionDetails) this.extractedRes.transactionDetails = [];

            this.extractedRes.transactionDetails.push({
              cells: [newTable],
              pageIndex: this.pageIndex,
            });
            this.showWordBlocks = false;
            await this.drawCanvas(true);
            this.save();
          }
          return;
        } else if (targetPartOfTable === true) {
          const uniqueRowIndex = [
            ...new Set(
              targetPage[targetPartOfTableIndex].cells.map((item) => item.rowIndex)),
          ];
          const firstRow = targetPage[targetPartOfTableIndex].cells.filter(
            (item) => {
              if (item.rowIndex === uniqueRowIndex[0]) {
                return item;
              }
            },
          );
          if (
            res.selectedAnnotation.boundingPoly.vertices[2].y < firstRow[0].boundingPoly.vertices[0].y
          ) {
            // add new row from above
            const newCells = [];
            for (let j = 0; j < firstRow.length; j++) {
              const wordsAnnotationArray = this.wordBlocks[
                this.pageIndex
              ].filter((item) => {
                if (
                  item.boundingPoly.vertices[0].x >= firstRow[j].boundingPoly.vertices[0].x &&
                  item.boundingPoly.vertices[1].x <= firstRow[j].boundingPoly.vertices[1].x &&
                  item.boundingPoly.vertices[0].y >= res.selectedAnnotation.boundingPoly.vertices[0].y - 2 &&
                  item.boundingPoly.vertices[3].y <= firstRow[j].boundingPoly.vertices[0].y
                ) {
                  return item;
                }
              });
              let line = '';
              const words = [];
              for (const el of wordsAnnotationArray) {
                line = line + ' ' + el.description;
                words.push(el.description);
              }
              newCells.push({
                blockType: 'CELL',
                columnIndex: firstRow[j].columnIndex,
                id: uuidv4(),
                rowIndex: 1,
                words: words,
                wordsAnnotationArray: wordsAnnotationArray,
                line: line,
                boundingPoly: {
                  vertices: [
                    {
                      x: firstRow[j].boundingPoly.vertices[0].x,
                      y: res.selectedAnnotation.boundingPoly.vertices[0].y - 2,
                    },
                    {
                      x: firstRow[j].boundingPoly.vertices[1].x,
                      y: res.selectedAnnotation.boundingPoly.vertices[0].y - 2,
                    },
                    {
                      x: firstRow[j].boundingPoly.vertices[1].x,
                      y: firstRow[j].boundingPoly.vertices[0].y,
                    },
                    {
                      x: firstRow[j].boundingPoly.vertices[0].x,
                      y: firstRow[j].boundingPoly.vertices[0].y,
                    },
                  ],
                },
              });
            }
            // Increment rowIndex of each cell by 1
            targetPage[targetPartOfTableIndex].cells = targetPage[
              targetPartOfTableIndex
            ].cells.filter((item) => {
              item.rowIndex = item.rowIndex + 1;
              return item;
            });
            // append new cells to top
            targetPage[targetPartOfTableIndex].cells = newCells.concat(targetPage[targetPartOfTableIndex].cells);
            this.showWordBlocks = false;
            this.update(targetPage);
            return;
          }
          return;
        }
      }
      if (yChange > xChange) {
        if (res.rect.attrs.y < res.selectedAnnotation.boundingPoly.vertices[0].y) {
          dargedUp = true;
        } else if (res.rect.attrs.y > res.selectedAnnotation.boundingPoly.vertices[0].y) {
          dragedDown = true;
        }
      } else if (yChange < xChange) {
        if (res.rect.attrs.x < res.selectedAnnotation.boundingPoly.vertices[0].x) {
          dragedLeft = true;
        } else if (res.rect.attrs.x > res.selectedAnnotation.boundingPoly.vertices[0].x) {
          dragedRight = true;
        }
      }

      let intDragRightTargetCellX;
      let intDragRightNextCellX;
      for (let i = 0; i < targetPage.length; i++) {
        let targetCell = targetPage[i].cells.filter((cell) => {
          return cell.id === selectedCell.id;
        });
        if (targetCell.length === 0) continue;
        
        let targetRowIndex = null;

        const reducer = (acc, curr) => {
            if ((dargedUp && curr.rowIndex < selectedCell.rowIndex && curr.rowIndex > acc) ||
                (dragedDown && curr.rowIndex > selectedCell.rowIndex && curr.rowIndex < acc)) {
                return curr.rowIndex;
            }
            return acc;
        };

        if (dargedUp) {
            targetRowIndex = targetPage[i].cells.reduce(reducer, -Infinity);
        } else if (dragedDown) {
            targetRowIndex = targetPage[i].cells.reduce(reducer, Infinity);
        }

        let targetRow = targetPage[i].cells.filter(cell => cell.rowIndex === targetRowIndex);

        const selectedRow = targetPage[i].cells.filter((cell) => {
          return cell.rowIndex === selectedCell.rowIndex;
        });

        // Fix if target row is missing first cell
      if (targetRow.length > 0 && selectedRow.length > targetRow.length && selectedCell.columnIndex === 1) {
        // Copy selectedCell and adjust bounds
        const temp = deepCopy(selectedCell);
        const selectedCellMidX = (temp.boundingPoly.vertices[1].x + temp.boundingPoly.vertices[0].x) / 2;
        // Add new cell at the beginning of targetRow
        if (selectedCellMidX < targetRow[0].boundingPoly.vertices[0].x) {
          temp.columnIndex = 1;
          temp.id = uuidv4();
          temp.words = [];
          temp.wordsAnnotationArray = [];

          // Update rowIndex for new cell and subsequent cells
          targetRow.unshift(temp);
          targetRow.forEach((cell, index) => {
            cell.columnIndex = index + 1;
            cell.rowIndex = targetRowIndex;
          });

          // Adjust boundingPoly for new cell
          const newBounds = deepCopy(temp.boundingPoly);
          newBounds.vertices[0].y = targetRow[1].boundingPoly.vertices[0].y;
          newBounds.vertices[1].y = targetRow[1].boundingPoly.vertices[0].y;
          newBounds.vertices[2].y = targetRow[1].boundingPoly.vertices[3].y;
          newBounds.vertices[3].y = targetRow[1].boundingPoly.vertices[3].y;
          targetRow[0].boundingPoly = newBounds;

          // Remove targetRow[0] from targetPage[i].cells and insert it at the right position
          const selectedCellIndex = targetPage[i].cells.findIndex(cell => cell.rowIndex === selectedCell.rowIndex);
          targetPage[i].cells.splice(selectedCellIndex, 0, ...targetRow);
          targetPage[i].cells = targetPage[i].cells.filter(cell => cell.rowIndex !== targetRowIndex);
        }
        await this.update(targetPage);
        return;
      }

        for (let j = 0; j < targetPage[i].cells.length; j++) {
          if (dargedUp) {
            if (targetPage[i].cells[j].rowIndex === targetRowIndex) {
              for (const el of selectedRow) {
                if (el.columnIndex === targetPage[i].cells[j].columnIndex) {
                  targetPage[i].cells[j].boundingPoly.vertices[2].y = el.boundingPoly.vertices[2].y;
                  targetPage[i].cells[j].boundingPoly.vertices[3].y = el.boundingPoly.vertices[3].y;
                  if (el.wordsAnnotationArray) {
                    targetPage[i].cells[j].wordsAnnotationArray = targetPage[i].cells[j].wordsAnnotationArray.concat(el.wordsAnnotationArray);
                    targetPage[i].cells[j].words = targetPage[i].cells[j].words.concat(el.words);
                    let line = '';
                    for (const word of targetPage[i].cells[j].words) {
                      line = line + ' ' + word;
                    }
                    targetPage[i].cells[j].line = line.trim();
                  }
                  dragUpDownFix = true;
                  break;
                }
              }
            }
          } else if (dragedDown) {
            //
            if (targetPage[i].cells[j].rowIndex === targetRowIndex) {
              for (let el = 0; el < selectedRow.length; el++) {
                if (selectedRow[el].columnIndex === targetPage[i].cells[j].columnIndex) {
                  targetPage[i].cells[j].boundingPoly.vertices[0].y = selectedRow[el].boundingPoly.vertices[0].y;
                  targetPage[i].cells[j].boundingPoly.vertices[1].y = selectedRow[el].boundingPoly.vertices[1].y;
                  if (
                    el === 100 &&
                    selectedRow[el].wordsAnnotationArray && // delete me
                    selectedRow[el].wordsAnnotationArray.length === 1 &&
                    selectedRow[el].wordsAnnotationArray[0].description &&
                    selectedRow[el].wordsAnnotationArray[0].description.match(/20\d{2}/)
                  ) {
                    const targetWordsAnnotationArray = targetPage[i].cells[j].wordsAnnotationArray;
                    const targetLastWordArray = targetWordsAnnotationArray[targetWordsAnnotationArray.length - 1];
                    const wordsAnnotationArray = selectedRow[0].wordsAnnotationArray;
                    const wordWidth = wordsAnnotationArray[0].boundingPoly.vertices[1].x - wordsAnnotationArray[0].boundingPoly.vertices[0].x;

                    wordsAnnotationArray[0].boundingPoly.vertices[0].x = targetLastWordArray.boundingPoly.vertices[1].x + 1;
                    wordsAnnotationArray[0].boundingPoly.vertices[0].y = targetLastWordArray.boundingPoly.vertices[0].y;
                    wordsAnnotationArray[0].boundingPoly.vertices[1].x = targetLastWordArray.boundingPoly.vertices[1].x + 1 + wordWidth;
                    wordsAnnotationArray[0].boundingPoly.vertices[1].y = targetLastWordArray.boundingPoly.vertices[1].y;
                    wordsAnnotationArray[0].boundingPoly.vertices[2].x = targetLastWordArray.boundingPoly.vertices[1].x + 1 + wordWidth;
                    wordsAnnotationArray[0].boundingPoly.vertices[2].y = targetLastWordArray.boundingPoly.vertices[2].y;
                    wordsAnnotationArray[0].boundingPoly.vertices[3].x = targetLastWordArray.boundingPoly.vertices[1].x + 1;
                    wordsAnnotationArray[0].boundingPoly.vertices[3].y = targetLastWordArray.boundingPoly.vertices[3].y;

                    targetPage[i].cells[j].wordsAnnotationArray = targetPage[i].cells[j].wordsAnnotationArray.concat(wordsAnnotationArray);
                    targetPage[i].cells[j].words = targetPage[i].cells[j].words.concat(selectedRow[el].words);

                    let line = '';
                    for (const word of targetPage[i].cells[j].words) {
                      line = line + ' ' + word;
                    }
                    targetPage[i].cells[j].line = line.trim();
                  } else if (selectedRow[el].wordsAnnotationArray) {
                    targetPage[i].cells[j].wordsAnnotationArray = selectedRow[el].wordsAnnotationArray.concat(targetPage[i].cells[j].wordsAnnotationArray);
                    targetPage[i].cells[j].words = selectedRow[el].words.concat(targetPage[i].cells[j].words);
                    let line = '';
                    for (const word of targetPage[i].cells[j].words) {
                      line = line + ' ' + word;
                    }
                    targetPage[i].cells[j].line = line.trim();
                  }
                  if (el === selectedRow.length - 1) {
                    dragUpDownFix = true;
                    break;
                  }
                }
              }
            }
          } else if (dragedRight) {
            const fix = (nextCell) => {
              targetPage[i].cells[j].boundingPoly.vertices[1].x = nextCell[0].boundingPoly.vertices[1].x;
              targetPage[i].cells[j].boundingPoly.vertices[2].x = nextCell[0].boundingPoly.vertices[2].x;
              if (nextCell[0].wordsAnnotationArray) {
                let wordsAnnotationArray = targetPage[i].cells[j].wordsAnnotationArray.concat(nextCell[0].wordsAnnotationArray);
                for (let z = 0; z < wordsAnnotationArray.length; z++) {
                  wordsAnnotationArray[z].midPoint = {
                    x: (wordsAnnotationArray[z].boundingPoly.vertices[0].x + wordsAnnotationArray[z].boundingPoly.vertices[1].x) / 2,
                    y: (wordsAnnotationArray[z].boundingPoly.vertices[0].y + wordsAnnotationArray[z].boundingPoly.vertices[2].y) / 2,
                  };
                }
                wordsAnnotationArray = wordsAnnotationArray.sort((a, b) => {
                  const yDifference = a.midPoint.y - b.midPoint.y;
                  if (Math.abs(yDifference) < 10)
                    return a.midPoint.x - b.midPoint.x;
                  else return yDifference;
                });

                let line = '';
                const words = [];
                for (const item of wordsAnnotationArray) {
                  words.push(item.description);
                  line = line + ' ' + item.description;
                }
                targetPage[i].cells[j].wordsAnnotationArray = wordsAnnotationArray;
                targetPage[i].cells[j].words = words;
                targetPage[i].cells[j].line = line.trim();

                // delete column next to it
                const updatedCells = [];
                for (let y = 0; y < targetPage[i].cells.length; y++) {
                  const cell = targetPage[i].cells[y];
                  if (cell.id === nextCell[0].id) {
                    continue;
                  } else if (
                    cell.rowIndex === nextCell[0].rowIndex &&
                    cell.columnIndex > nextCell[0].columnIndex
                  ) {
                    cell.columnIndex = cell.columnIndex - 1;
                    updatedCells.push(cell);
                  } else {
                    updatedCells.push(cell);
                  }
                }
                targetPage[i].cells = updatedCells;
                j = j + 1;
              }
            };
            if (
              targetPage[i].cells[j].rowIndex === selectedCell.rowIndex &&
              targetPage[i].cells[j].columnIndex === selectedCell.columnIndex
            ) {
              if (!intDragRightTargetCellX) {
                const temp1 = targetPage[i].cells.filter((cell) => {
                  if (
                    cell.rowIndex === selectedCell.rowIndex &&
                    cell.columnIndex === selectedCell.columnIndex
                  )
                    return cell;
                });
                intDragRightTargetCellX = temp1[0].boundingPoly.vertices[1].x;
                const temp2 = targetPage[i].cells.filter((cell) => {
                  if (
                    cell.rowIndex === selectedCell.rowIndex &&
                    cell.columnIndex === selectedCell.columnIndex + 1
                  )
                    return cell;
                });
                intDragRightNextCellX = temp2[0].boundingPoly.vertices[0].x;
              }
              let nextCell = targetPage[i].cells.filter((cell) => {
                if (
                  cell.rowIndex === selectedCell.rowIndex &&
                  cell.columnIndex === selectedCell.columnIndex + 1
                )
                  return cell;
              });

              if (nextCell.length > 0) {
                fix(nextCell);
                await this.drawCanvas(true);
                await this.save();
                updated = true;
                await this.dialogService
                  .open(DialogComponent, {
                    context: {
                      body: '!!! Please Confirm !!!',
                      header: 'Do you wish to update subsequent rows?',
                    },
                    closeOnBackdropClick: false,
                  })
                  .onClose.subscribe(async (data) => {
                    if (data && data.value === 'YES') {
                      const uniqeRowInedex = [];
                      targetPage[i].cells.filter((cell) => {
                        if (
                          cell.rowIndex > selectedCell.rowIndex &&
                          !uniqeRowInedex.includes(cell.rowIndex)
                        )
                          uniqeRowInedex.push(cell.rowIndex);
                      });
                      for (let z = 0; z < uniqeRowInedex.length; z++) {
                        targetCell = targetPage[i].cells.filter((cell) => {
                          if (
                            cell.rowIndex === uniqeRowInedex[z] &&
                            cell.columnIndex === selectedCell.columnIndex
                          )
                            return cell;
                        });
                        j = targetPage[i].cells.indexOf(targetCell[0]);
                        nextCell = targetPage[i].cells.filter((cell) => {
                          if (
                            cell.rowIndex === uniqeRowInedex[z] &&
                            cell.columnIndex === selectedCell.columnIndex + 1
                          )
                            return cell;
                        });

                        if (nextCell.length === 0 || targetCell.length === 0) {
                          j = targetPage[i].cells.length + 2;
                          // this.drawCanvas(true);
                          break;
                        } else if (
                          nextCell.length > 0 &&
                          targetCell.length > 0 &&
                          Math.abs(targetCell[0].boundingPoly.vertices[1].x - intDragRightTargetCellX) < 5 &&
                          Math.abs(nextCell[0].boundingPoly.vertices[0].x - intDragRightNextCellX) < 5
                        ) {
                          fix(nextCell);
                          j = targetPage[i].cells.length + 2;
                          // await this.drawCanvas(true);
                        } else {
                          j = targetPage[i].cells.length + 2;
                          // await this.drawCanvas(true);
                          break;
                        }
                      }
                      await this.save();
                      await this.drawCanvas(true);
                    }
                  });
              }
            }
          }
        }
        if (dragUpDownFix) {
          // remove selected cell
          targetPage[i].cells = targetPage[i].cells.filter((cell) => {
            if (cell.rowIndex !== selectedCell.rowIndex) {
              return cell;
            }
          });
          // re order rowIndex
          targetPage[i].cells = targetPage[i].cells.filter((cell) => {
            if (cell.rowIndex > selectedCell.rowIndex) {
              cell.rowIndex = cell.rowIndex - 1;
              return cell;
            } else {
              return cell;
            }
          });
          this.drawCanvas(true);
          updated = true;
          break;
        }
      }
    } else if (res.eventType === 'horizontalLine') {
      this.fixSuggestions = this.fixSuggestions.filter((item) => {
        if (item.pageIndex !== this.pageIndex) {
          return item;
        }
      });

      const linePos = res.linePos.sort((a: any, b: any) => a.x - b.x);

      for (const item of linePos) {
        let posY = parseFloat(item.y.toFixed());
        let posX = parseFloat(item.x.toFixed());
        let posAdjusted = posY;

        let targetRow = [];
        let targetTableIndex;

        for (let k = 0; k < targetPage.length; k++) {
          const bounds = this.tableBounds[k];
          if (bounds.yTopArr[0] <= posY && bounds.yBottomArr[bounds.yBottomArr.length - 1] >= posY) {
            targetTableIndex = k;
            targetRow = targetPage[k].cells.filter((cell) => cell.boundingPoly.vertices[1].y < posY && cell.boundingPoly.vertices[2].y > posY);
            break;
          }
        }

        const targetRowIndex = targetRow[0].rowIndex;
        const modified = [];
        for (let i = 0; i < targetRow.length; i++) {
          const temp = targetRow[i];

          const wordsAnnotationArray = temp.wordsAnnotationArray ? temp.wordsAnnotationArray.filter((items) => items.boundingPoly.vertices[1].y <= posY) : [];

          const words = [];
          let line = '';
          for (const items of wordsAnnotationArray) {
            words.push(items.description);
            line += ' ' + items.description;
            if (items.boundingPoly.vertices[2].y > posY) {
              posAdjusted = items.boundingPoly.vertices[2].y;
            }
            if (items.boundingPoly.vertices[3].y > posAdjusted) {
              posAdjusted = items.boundingPoly.vertices[3].y;
            }
          }

          const data = {
            blockType: 'CELL',
            id: `${uuidv4()}-(adRwAbv-PId-${temp.id})`,
            parentRowId: temp.id,
            rowIndex: temp.rowIndex,
            columnIndex: temp.columnIndex,
            wordsAnnotationArray: wordsAnnotationArray,
            words,
            line: line.trim(),
            boundingPoly: {
              vertices: [
                { x: temp.boundingPoly.vertices[0].x, y: temp.boundingPoly.vertices[0].y },
                { x: temp.boundingPoly.vertices[1].x, y: temp.boundingPoly.vertices[1].y },
                { x: temp.boundingPoly.vertices[2].x, y: posY },
                { x: temp.boundingPoly.vertices[3].x, y: posY },
              ],
            },
          };
          modified.push(data);
        }

        for (let i = 0; i < targetRow.length; i++) {
          const temp = targetRow[i];
          const wordsAnnotationArray = temp.wordsAnnotationArray ? temp.wordsAnnotationArray.filter((items) => items.boundingPoly.vertices[1].y > posY) : [];

          const words = [];
          let line = '';
          for (const items of wordsAnnotationArray) {
            words.push(items.description);
            line += ' ' + items.description;
          }
          const data = {
            blockType: 'CELL',
            id: `${uuidv4()}-(adRwBlw-PRowId-${temp.id})`,
            parentRowId: temp.id,
            rowIndex: temp.rowIndex + 1,
            columnIndex: temp.columnIndex,
            wordsAnnotationArray: wordsAnnotationArray,
            words,
            line: line.trim(),
            boundingPoly: {
              vertices: [
                { x: temp.boundingPoly.vertices[0].x, y: posY },
                { x: temp.boundingPoly.vertices[1].x, y: posY },
                { x: temp.boundingPoly.vertices[2].x, y: temp.boundingPoly.vertices[2].y },
                { x: temp.boundingPoly.vertices[3].x, y: temp.boundingPoly.vertices[3].y },
              ],
            },
          };
          modified.push(data);
        }

        const updatedTable = [];
        let targetFound = false;
        for (const temp of targetPage[targetTableIndex].cells) {
          if (temp.rowIndex === targetRowIndex) {
            if (targetFound) continue;
            for (let j = 0; j < modified.length; j++) {
                const modifiedVertex = modified[j].boundingPoly.vertices;
                const posYAdjusted = posAdjusted;
                for (let v = 0; v < 4; v++) {
                  if (modifiedVertex[v].y === posY) modifiedVertex[v].y = posYAdjusted;
                }
                updatedTable.push(modified[j]);
            }
            targetFound = true;
          } else {
            if (targetFound) temp.rowIndex += 1;
            updatedTable.push(temp);
          }
        }
        targetPage[targetTableIndex].cells = updatedTable;
        updated = true;
      }
    } else if (res.eventType === 'verticalLine') {
      const linePos = res.linePos.sort((a: any, b: any) => a.x - b.x);

      let targetTableIndex;
      const updatedTable = [];
      for (const item of linePos) {
        let posX = parseFloat(item.x.toFixed());
        let posY = parseFloat(item.y.toFixed());
        let targetTable;
        for (let k = 0; k < targetPage.length; k++) {
          if (
            this.tableBounds[k].xLeftArr[0] <= posX &&
            this.tableBounds[k].xRightArr[this.tableBounds[k].xRightArr.length - 1] >= posX &&
            this.tableBounds[k].yTopArr[0] <= posY + 7 && // 5 offset from image box editor
            this.tableBounds[k].yBottomArr[this.tableBounds[k].yBottomArr.length - 1] >= posY
          ) {
            targetTable = targetPage[k];
            targetTableIndex = k;
            break;
          }
        }
        const uniqueRowIndex = [
          ...new Set(targetTable.cells.map((items) => items.rowIndex)),
        ];
        for (let i = 0; i < uniqueRowIndex.length; i++) {
          const targetRow = targetTable.cells.filter((cell) => {
            if (cell.rowIndex === uniqueRowIndex[i]) {
              return cell;
            }
          });
          if (posX < targetRow[0].boundingPoly.vertices[0].x) {
            // add first column
            const data = {
              blockType: 'CELL',
              id: `${uuidv4()}-(splitCell-firstColumn)`,
              parentColumnId: null,
              rowIndex: uniqueRowIndex[i],
              columnIndex: targetRow[0].columnIndex,
              wordsAnnotationArray: [],
              words: [],
              line: '',
              boundingPoly: {
                vertices: [
                  { x: posX, y: targetRow[0].boundingPoly.vertices[0].y },
                  { x: targetRow[0].boundingPoly.vertices[0].x, y: targetRow[0].boundingPoly.vertices[0].y },
                  { x: targetRow[0].boundingPoly.vertices[3].x, y: targetRow[0].boundingPoly.vertices[3].y },
                  { x: posX, y: targetRow[0].boundingPoly.vertices[3].y },
                ],
              },
            };
            updatedTable.push(data);
            for (let j = 0; j < targetRow.length; j++) {
              const newColumnIndex = targetRow[j].columnIndex + 1;
              const temp = targetRow[j];
              temp.columnIndex = newColumnIndex;
              updatedTable.push(temp);
            }
          } else {
            // split existing columns
            let splitCellPerformed = false;
            const updatedRow = [];
            for (let k = 0; k < targetRow.length; k++) {
              const column: any = targetRow[k];
              if (
                column.boundingPoly.vertices[0].x < posX &&
                column.boundingPoly.vertices[1].x > posX
              ) {
                splitCellPerformed = true;
                const wordsAnnotationArray = column.wordsAnnotationArray;
                const column1WordsAnnotationArray = [];
                let column1Line = '';
                const column1Words = [];
                const column2WordsAnnotationArray = [];
                let column2Line = '';
                const column2Words = [];
                if (wordsAnnotationArray.length > 0) {
                  wordsAnnotationArray.filter((item) => {
                    if (item.boundingPoly.vertices[1].x <= posX) {
                      column1WordsAnnotationArray.push(item);
                      if (item.description) {
                        column1Line = column1Line + ' ' + item.description;
                        column1Words.push(item.description);
                      }
                    } else {
                      column2WordsAnnotationArray.push(item);
                      if (item.description) {
                        column2Line = column2Line + ' ' + item.description;
                        column2Words.push(item.description);
                      }
                    }
                  });
                }
                const column1: any = {
                  blockType: 'CELL',
                  id: `${uuidv4()}-(splitCell-parentColumnId-${column.id})`,
                  parentColumnId: column.id,
                  rowIndex: column.rowIndex,
                  columnIndex: column.columnIndex,
                  wordsAnnotationArray: column1WordsAnnotationArray,
                  words: column1Words,
                  line: column1Line.trim(),
                  boundingPoly: {
                    vertices: [
                      { x: column.boundingPoly.vertices[0].x, y: column.boundingPoly.vertices[0].y },
                      { x: posX, y: column.boundingPoly.vertices[1].y },
                      { x: posX, y: column.boundingPoly.vertices[2].y },
                      { x: column.boundingPoly.vertices[3].x, y: column.boundingPoly.vertices[3].y },
                    ],
                  },
                };

                const column2: any = {
                  blockType: 'CELL',
                  id: `${uuidv4()}-(splitCell-parentColumnId-${column.id})`,
                  parentColumnId: column.id,
                  rowIndex: column.rowIndex,
                  columnIndex: column.columnIndex + 1,
                  wordsAnnotationArray: column2WordsAnnotationArray,
                  words: column2Words,
                  line: column2Line.trim(),
                  boundingPoly: {
                    vertices: [
                      { x: posX, y: column.boundingPoly.vertices[0].y },
                      { x: column.boundingPoly.vertices[1].x, y: column.boundingPoly.vertices[1].y },
                      { x: column.boundingPoly.vertices[2].x, y: column.boundingPoly.vertices[2].y },
                      { x: posX, y: column.boundingPoly.vertices[3].y },
                    ],
                  },
                };
                if (column.entityTypes) {
                  column1.entityTypes = column.entityTypes;
                  column2.entityTypes = column.entityTypes;
                }
                updatedRow.push(column1);
                updatedRow.push(column2);
              } else {
                const updatedColumn = column;
                if (splitCellPerformed) {
                  updatedColumn.columnIndex = updatedColumn.columnIndex + 1;
                }
                updatedRow.push(updatedColumn);
              }
            }
            let modifiedCells = [];
            if (updatedRow.length > 0) {
              updated = false;
              targetTable.cells.filter((item) => {
                if (updated && item.rowIndex === targetRow[0].rowIndex) {
                  // do nothing
                } else if (item.rowIndex === targetRow[0].rowIndex) {
                  updated = true;
                  modifiedCells = modifiedCells.concat(updatedRow);
                } else {
                  modifiedCells.push(item);
                }
              });
            }
            targetPage[targetTableIndex].cells = modifiedCells;
            updated = true;
          }
        }
      }
    } else if (res.eventType === 'delete') {
      const selectedCell = res.selectedCell;
      for (let i = 0; i < targetPage.length; i++) {
        const target = targetPage[i].cells.filter((item) => {
          if (item.id === selectedCell.id) {
            return item;
          }
        });

        let targetRow = targetPage[i].cells.filter(cell => cell.rowIndex === selectedCell.rowIndex);
        const rowBelow = targetPage[i].cells.filter(cell => cell.rowIndex > selectedCell.rowIndex);

        if (target.length > 0) {
          if (res.deleteType === 'CELL') {
            targetPage[i].cells = targetPage[i].cells.filter(item => item.id !== selectedCell.id);
          } else if (res.deleteType === 'ROW') {

            // If row has no date - get date from row above
            const rowHasDate = row => row.length > 0 && row[0].line && row[0].line.match(datePatternWithoutYear);
            if ((!rowBelow[0].line || (rowBelow[0].line && !rowHasDate(rowBelow))) && rowHasDate(targetRow)) {
              targetPage[i].cells = targetPage[i].cells.filter((cell) => {
                if (cell.id === rowBelow[0].id) {
                  cell.line = targetRow[0].line;
                  cell.words = targetRow[0].words;
                  let targetRowWordsAnnotationArray = deepCopy(targetRow[0].wordsAnnotationArray);
                  const incrementFactor = cell.boundingPoly.vertices[0].y - targetRow[0].wordsAnnotationArray[0].boundingPoly.vertices[0].y + 2;
                  targetRowWordsAnnotationArray.forEach(word => {
                    word.boundingPoly.vertices.forEach(vertex => vertex.y += incrementFactor);
                  });
                  cell.wordsAnnotationArray = targetRowWordsAnnotationArray;
                }
                return cell;
            });
            };
          } else if (res.deleteType === 'ROW') {
            targetPage[i].cells = targetPage[i].cells.filter((item) => {
              if (item.rowIndex !== selectedCell.rowIndex) {
                return item;
              }
              });
          } else if (res.deleteType === 'ROW') {
            targetPage[i].cells = targetPage[i].cells.filter((item) => {
              if (item.rowIndex !== selectedCell.rowIndex) {
                return item;
              }
            });
          } else if (res.deleteType === 'TABLE') {
            targetPage[i].cells.filter((item) => {
              if (item.id === selectedCell.id) {
                targetPage.splice(i, 1);
                return;
              }
            });
          }
          await this.update(targetPage);
          break;
        }
      }
    }
    if (updated) {
      await this.update(targetPage);
    }
  }

  async update(targetPage) {
    await this.drawCanvas(true);
    if (this.fetchAllTables) {
      this.extractedRes.allTables = this.extractedRes.allTables.filter((item) => { return item.pageIndex !== this.pageIndex; });
      this.extractedRes.allTables = this.extractedRes.allTables.concat(targetPage);
    } else {
      this.extractedRes.transactionDetails =
        this.extractedRes.transactionDetails.filter((item) => {
          return item.pageIndex !== this.pageIndex;
        });
      this.extractedRes.transactionDetails = this.extractedRes.transactionDetails.concat(targetPage);
    }
    await this.save();
  }

  myMouseClicked(e) {
    if (e.target.className === 'box stack-toop') {
      this.header.nativeElement.style.zIndex = 1;
      this.displayStandardFields = false;
    }
    this.injectToHeaderToolbar();
  }

  normalCase(value: string): string {
    if (value && value !== '') {
      return (
        value
          // insert a space before all caps
          .replace(/([A-Z])/g, ' $1')
          // uppercase the first character
          .replace(/^./, function (str) {
            return str.toUpperCase();
          })
      );
    } else {
      return null;
    }
  }

  async validateAllPages(reinit) {
    try {
      if (this.fetchAllTables) return;
  
      const { tableArray, header, skipValidationCheck } = this.getTableArray(true);
      if (skipValidationCheck && !reinit) return;
  
      const allFilteredTableArray = this.filterTableArray(tableArray, header);
      const res: any = await Helper.validateHelper(allFilteredTableArray, reinit, true);
  
      if (res.autoFixes.length > 0) {
        await this.save();
      }
  
      const balanceCheckErrorPages = Array.from(new Set(res.errPageNos));
  
      this.balanceCheckErrorPages = balanceCheckErrorPages;
      this.errorPagesConsolidated = [...new Set([...this.errorPages, ...this.balanceCheckErrorPages])];
      this.errorPagesConsolidated.sort();
  
      if (reinit && !this.errorPages.includes(this.pageIndex + 1)) {
        this.errorPageClick = 0;
      }
    } catch (err) {
      console.log('validateAllPages err', err);
    }
  }

  async validate(reinit, isInitialLoading) {
    try {
      const { tableArray, skipValidationCheck } = this.getTableArray();
      if (isInitialLoading && skipValidationCheck) {
        this.dialogService.open(DialogComponent, {
          context: {
            body: "!!! Skipping validation check; please verify if the table is missing the balance header. !!!",
            header: "Error",
            dialogType: "info",
          },
          closeOnBackdropClick: false,
        });
        return;
      } else if (skipValidationCheck) {
        return;
      }

      const { reverseTrans, tableArrayAll } = Helper.fixStatementsInReverseOrder([], tableArray);

      // Filter transactions for the current, next, and previous pages
      const currentPageTrans = tableArrayAll.filter(item => item && item[0] && item[0].pageIndex === this.pageIndex);
      const nextPageTrans = tableArrayAll.filter(item => item && item[0] && item[0].pageIndex === this.pageIndex + 1);
      const previousPageTrans = tableArrayAll.filter(item => item && item[0] && item[0].pageIndex === this.pageIndex - 1);

      // Determine if the user is on page 1
      const isFirstPage = this.pageIndex === 0 || (this.extractedRes.transactionDetails[0].pageIndex === this.pageIndex);

      // Determine the filtered transactions based on user settings and page location
      let filteredTableArray;
      if (isFirstPage) {
          if (reverseTrans) {
              filteredTableArray = nextPageTrans.length > 0 ? [nextPageTrans[nextPageTrans.length - 1]].concat(currentPageTrans) : currentPageTrans;
          } else {
              filteredTableArray = nextPageTrans.length > 0 ? currentPageTrans.concat([nextPageTrans[0]]) : currentPageTrans;
          }
      } else {
          if (reverseTrans) {
              filteredTableArray = previousPageTrans.length > 0 ? currentPageTrans.concat([previousPageTrans[0]]) : currentPageTrans;
          } else {
              filteredTableArray = previousPageTrans.length > 0 ? [previousPageTrans[previousPageTrans.length - 1]].concat(currentPageTrans) : currentPageTrans;
          }
      }

      return await Helper.validateHelper(filteredTableArray, reinit, false);
    } catch (err) {
      console.log('validate err', err);
    }
  }

  headerToggle(e) {
    if (e && e.displayStandardFields) {
      this.header.nativeElement.style.zIndex = 2;
      this.displayStandardFields = true;
    } else {
      this.header.nativeElement.style.zIndex = 1;
      this.displayStandardFields = false;
    }
    this.injectToHeaderToolbar();
  }

  identifyFixSuggestions (extractedRes) {
    let transactionDetails = extractedRes ? extractedRes.transactionDetails : [];
      
    transactionDetails.sort((a, b) => a.pageIndex - b.pageIndex);
    for (let l = 0; l < transactionDetails.length; l++) {
      let transaction = transactionDetails[l];
      const pageIndex = transaction.pageIndex;
      // Iterate over each cell in the transaction
      let fixSuggestions = [];
      for (let m = 0; m < transaction.cells.length; m++) {
        let cell = deepCopy(transaction.cells[m]);
          if (cell.line && cell.line.match(/Brought forward/i) && !cell.line.trim().match(/^Brought forward$/i)) {
            const broughtBlock = cell.wordsAnnotationArray.find(block => block.description === "Brought");
            const forwardBlock = cell.wordsAnnotationArray.find(block => block.description === "forward");

            if (broughtBlock && forwardBlock) {
                // Find minimum and maximum y coordinates
                const minY = Math.min(broughtBlock.boundingPoly.vertices[0].y, forwardBlock.boundingPoly.vertices[0].y);
                const maxY = Math.max(broughtBlock.boundingPoly.vertices[2].y, forwardBlock.boundingPoly.vertices[2].y);
                const wordHeight = maxY - minY;
                const spaceRemaining = cell.boundingPoly.vertices[3].y - wordHeight;
                if (spaceRemaining > wordHeight) {
                  fixSuggestions.push({
                    boundingPoly: cell.boundingPoly,
                    description: cell.line ? cell.line : '',
                    cell,
                    y: maxY - (rightCanvasOfstY),
                    tableIndex: 0,
                    pageIndex
                  })
                }
            } else {
                console.log("One or both of the words 'Brought' and 'forward' are missing in the blocks.");
            }
          }
      };
      return fixSuggestions;
    }
  }

  getTableArray(alertForErrros = false, extractedRes = null) {
    try {
      let transactionDetails = extractedRes ? extractedRes.transactionDetails : this.extractedRes.transactionDetails;
      
      transactionDetails.sort((a, b) => a.pageIndex - b.pageIndex);
      
      if (alertForErrros && transactionDetails.length === 0 && this.pageIndex === 0) {
        this.dialogService.open(DialogComponent, {
          context: {
            body: "!!! No transactions found. !!!",
            header: "Warning",
            dialogType: "info",
          },
          closeOnBackdropClick: false,
        });
        return;
      }
      let tableArray = [];
      let header = [];
      let headerRowIndex;
      transactionDetails[0].cells.filter((item) => {
          if (item.entityTypes && item.entityTypes.length > 0 && item.entityTypes[0] === 'COLUMN_HEADER') {
            headerRowIndex = item.rowIndex;
            header.push(item);
          }
          if (!headerRowIndex && item.line && item.line.match(/DATE|DEBIT|CREDIT|BALANCE/i)) {
            headerRowIndex = item.rowIndex
          }
      });
  
      if (header.length === 0 && headerRowIndex) {
        transactionDetails[0].cells.filter((item) => {
          if (item.rowIndex === headerRowIndex) {
            header.push(item);
          }
      });
      }
  
      let isFirstIteration = true;
      // Iterate over each transaction detail
      transactionDetails.forEach((transaction) => {
          let excludeRowIndex = null;

          // Iterate over each cell in the transaction
          transaction.cells.forEach((cell) => {
              // Check if it's the first iteration and if the line matches "Brought forward"
              if (isFirstIteration && cell.line && cell.line.trim().match(/^Brought forward$/i)) {
                  // Skip this iteration
                  return;
              }

              // Check if the line matches "Carried forward"
              if (cell.line && cell.line.trim().match(/^(Bala\w+ *Carr\w+ *forwa\w+|Bala\w+ *Brou\w+ *forwa\w+|Carried forward|Brought forward|TOTALS AT END OF PAGE|TOTALS AT END OF PERIOD)$/i)) {
                  // Get the rowIndex to exclude
                  excludeRowIndex = cell.rowIndex;
              } else if (cell.line && cell.line.trim().match(/^(Internet *Banking *Transaction *History)$/i)) {
                const row = transaction.cells.filter((item) => {
                  return item.rowIndex === cell.rowIndex;
                });
                if (row.length === 5 && !row[row.length - 2].line && !row[row.length - 3].line) {
                  excludeRowIndex = cell.rowIndex;
                }
            }
          });

          // If rowIndex to exclude is found, filter out the cells with that rowIndex
          if (excludeRowIndex !== null) {
              transaction.cells = transaction.cells.filter(cell => cell.rowIndex !== excludeRowIndex);
          }

          // Set isFirstIteration to false after the first iteration
          isFirstIteration = false;
      });

      for (let j = 0; j < transactionDetails.length; j++) {
        const transactionDetail = transactionDetails[j].cells;
        const pageIndex = transactionDetails[j].pageIndex;
        let value = [];
  
        for (let i = 0; i < transactionDetail.length; i++) {
          transactionDetail[i].pageIndex = pageIndex;
          if (header.length > 0 && ((j === 0 && transactionDetail[i].rowIndex > header[0].rowIndex) || j > 0)) {
            if (transactionDetail[i]) {
              if (value.length === 0 && transactionDetail[i].columnIndex === 1) {
                value.push(transactionDetail[i]);
              } else if (
                value.length > 0 &&
                transactionDetail[i].columnIndex - 1 ===
                  value[value.length - 1].columnIndex
              ) {
                value.push(transactionDetail[i]);
                if (i === transactionDetail.length - 1) {
                  tableArray.push(value);
                  value = [];
                }
              } else if (
                value.length > 0 &&
                transactionDetail[i].columnIndex === 1
              ) {
                tableArray.push(value);
                value = [];
                value.push(transactionDetail[i]);
              }
            }
          }
        }
      }
  
      // check if header.length < 5; check if balance column missing
      let skipValidationCheck = false;
      if (tableArray.length > 0 && header.length < 5 && header.length === tableArray[0].length) {
        let foundBalanceHeader = false;
        header.filter((item) => {
          if (item.line && item.line.match(/Bal/)) {
            foundBalanceHeader = true;
          }
        });
  
      if (!foundBalanceHeader) skipValidationCheck = true;
      }
  
      tableArray = tableArray.filter((row) => {
        let line = '';
        row.filter((item) => {
          line += item.line;
        });
  
        if (line && line.match(/Debit|Credit|Date|bala|withdr|depos/i) && !line.match(/\d/)) {
          // no action needed
        } else {
          return row;
        }
      });
      
      return {
        tableArray,
        header,
        skipValidationCheck
      };
    } catch (err) {
      return {
        tableArray: [],
        header: [],
        skipValidationCheck: false
      };
    }
  }

  filterTableArray(tableArray, header, format = 'D + C') {
    try {
      this.generalErrors = [];
      let missingBalCol = false;
      let modified: any = [];

      let noBalanceColumn = false;

      let debitHeaderColumnIndex;
      let creditHeaderColumnIndex;

      header.filter((item) => {
        if (item.line && item.line.match(/Debit/i)) {
          debitHeaderColumnIndex = item.columnIndex;
        } else if (item.line && item.line.match(/Credit/i)) {
          creditHeaderColumnIndex = item.columnIndex;
        }
      });

      if (creditHeaderColumnIndex && debitHeaderColumnIndex && creditHeaderColumnIndex < debitHeaderColumnIndex) {
        // fix - Statement in order Credit | Debit | Balance; usually Debit | Credit | Balance
        console.log('fix - Statement in order Credit | Debit | Balance; usually Debit | Credit | Balance');
        const modifiedTableArray = tableArray.filter((item) => {
          if (item.length > 4) {
            const temp = item[item.length - 3];
            item[item.length - 3] = item[item.length - 2];
            item[item.length - 2] = temp;
          }
          return item;
        });
        tableArray = modifiedTableArray;
      }

      const totalCellsGreaterThanFive = [];
      const totalCellsEqualsfive = [];
      const totalCellsEqualsFour = [];
      const totalCellsLessThanFour = [];

      for (let index = 0; index < tableArray.length; index++) {
        const temp = tableArray[index];
        const temp1 = [];

        for (let i = 0; i < temp.length; i++) {
          temp[i].line = this.filterWords(temp[i].wordsAnnotationArray);
        }

        if (format === 'D + C') {
          // Debit Credit combined to 1 cell
          if (temp.length > 4) {
            let partOfDescription = '';
            if (
              header[0].line &&
              header[1].line &&
              header[0].line.match(/Date/i) &&
              header[1].line.match(/Date/i) &&
              temp.length > 5
            ) {
              temp1.push(temp[1]);
              temp1.push(temp[2]);
              if (temp[0].line && temp[0].line.match(/open|clos|bal/i))
                partOfDescription = temp[0].line;
              if (temp[1].line && temp[1].line.match(/open|clos|bal/i)) {
                partOfDescription = partOfDescription + ' ' + temp[1].line;
                temp1[0].line = '';
                temp1[1].line = partOfDescription + temp1[1].line;
              }
            } else {
              temp1.push(temp[0]);
              temp1.push(temp[1]);
            }
            if (temp[temp.length - 3].line && temp[temp.length - 2].line) {
              this.generalErrors.push([
                temp[temp.length - 3].pageIndex + 1,
                temp[temp.length - 3].rowIndex,
                'Invalid: Both debit and credit columns have values',
              ]);
            } else if (
              temp[temp.length - 2].line &&
              temp[temp.length - 2].line.match(/[.]/g) &&
              temp[temp.length - 2].line.match(/[.]/g).length > 1
            ) {
              this.generalErrors.push([
                temp[temp.length - 2].pageIndex + 1,
                temp[temp.length - 2].rowIndex,
                'Invalid: Could be 2 rows combined',
              ]);
            } else if (
              temp[temp.length - 1].line &&
              temp[temp.length - 1].line.match(/[.]/g) &&
              temp[temp.length - 1].line.match(/[.]/g).length > 1
            ) {
              this.generalErrors.push([
                temp[temp.length - 1].pageIndex + 1,
                temp[temp.length - 1].rowIndex,
                'Invalid: Could be 2 rows combined or have multiple dots in the balance column',
              ]);
            } else if (
              temp[temp.length - 3].line &&
              temp[temp.length - 3].line.match(/[.]/g) &&
              temp[temp.length - 3].line.match(/[.]/g).length > 1
            ) {
              this.generalErrors.push([
                temp[temp.length - 3].pageIndex + 1,
                temp[temp.length - 3].rowIndex,
                'Invalid: Could be 2 rows combined or have multiple dots in the debit/credit column',
              ]);
            } else if (
              temp[0].line &&
              temp[0].line.match(datePatternWithoutYear) &&
              temp[0].line.match(datePatternWithoutYear).length > 1
            ) {
              this.generalErrors.push([
                temp[0].pageIndex + 1,
                temp[0].rowIndex,
                `Invalid: 2 dates in column 1`,
              ]);
            } else if (
              !temp[temp.length - 2].line &&
              !temp[temp.length - 3].line &&
              (temp[1].line && !temp[1].line.match(/Closin|Carried forward|Brought forward|END OF PERIOD|END OF PAGE|OPENING BALANCE|Account *Open/i)) // last column
            ) {
              if (!tableArray[index - 1]) continue;
              if (tableArray[index + 1] && tableArray[index + 1][0].pageIndex !== tableArray[index][0].pageIndex) { // Ignore - Page Wrapping - Part of line in next page
                if (tableArray[index].length === tableArray[index + 1].length) {
                  for (let i = 1; i < tableArray[index + 1].length; i++ ) {
                    tableArray[index + 1][i].topLine = tableArray[index][i].line;
                  }
                }
                continue;
              }
              
              this.generalErrors.push([
                temp[temp.length - 3].pageIndex + 1,
                temp[temp.length - 3].rowIndex,
                'The row below or above could be part of an existing column, or it may not represent a transaction line.',
              ]);
            } else if (
              !temp[0].line &&
              !temp[1].line &&
              !temp[2].line &&
              !temp[3].line
            ) {
              this.generalErrors.push([
                temp[temp.length - 3].pageIndex + 1,
                temp[temp.length - 3].rowIndex,
                'Invalid: Blank Row',
              ]);
            } else if (
              !temp[temp.length - 2].line &&
              !temp[temp.length - 3].line
            ) {
              if (temp[1].line && temp[1].line.match(/Closin|Carried forward|Brought forward|END OF PERIOD|END OF PAGE|OPENING BALANCE|Account *Open/i)) {
                // no action needed; it has value in balance column
              } else {
                this.generalErrors.push([
                  temp[temp.length - 3].pageIndex + 1,
                  temp[temp.length - 3].rowIndex,
                  'Invalid: The row below or above could be part of an existing column, or it may not represent a transaction line.',
                ]);
              }
            } 

            if (temp[temp.length - 3].line) {
              if (!temp[temp.length - 3].line.includes('-')) {
                temp[temp.length - 3].line = '-' + temp[temp.length - 3].line;
                temp1.push(temp[temp.length - 3]);
              } else {
                temp1.push(temp[temp.length - 3]);
              }
            } else if (temp[temp.length - 2]) {
              temp1.push(temp[temp.length - 2]);
            }
            temp1.push(temp[temp.length - 1]);
          } else if (
            temp.length === 4 &&
            header.length === 4 &&
            header[3].line &&
            !header[3].line.match(/balan/i)
          ) {
            missingBalCol = true;
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            if (temp[2].line) {
              if (!temp[2].line.includes('-')) {
                temp[2].line = '-' + temp[2].line;
                temp1.push(temp[2]);
              } else {
                temp1.push(temp[2]);
              }
            } else {
              temp1.push(temp[3]);
            }
            temp1.push({
              line: '',
            });
          } else if (temp.length === 4) {
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            temp1.push(temp[2]);
            temp1.push(temp[3]);
          } else if ( // credit card statement with no balance
            temp.length === 3 &&
            header.length === 3 &&
            header[2].line.match(/amount|debit/i) &&
            !header[2].line.match(/bal/i)
          ) {
            noBalanceColumn = true;
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            if (temp[2].line) {
              temp1.push(temp[2]);
            } else {
              temp1.push({
                line: '',
              });
            }
            temp1.push({
              line: '',
            });
          }

          modified.push(temp1);

          if (temp.length === 5) {
            totalCellsEqualsfive.push(temp);
          } else if (temp.length === 4) {
            totalCellsEqualsFour.push(temp);
          } else if (temp.length < 4) {
            totalCellsLessThanFour.push(temp);
          } else if (temp.length > 5) {
            totalCellsGreaterThanFive.push(temp);
          }
        } else if (format === 'D | C') {
          // Debit Credit in seperate column
          if (temp.length > 4) {
            let partOfDescription = '';
            if (
              header[0].line &&
              header[0].line.match(/Date/i) &&
              header[1].line.match(/Date/i) &&
              temp.length > 5
            ) {
              temp1.push(temp[1]);
              temp1.push(temp[2]);
              if (temp[0].line && temp[0].line.match(/open|clos|bal/i))
                partOfDescription = temp[0].line;
              if (temp[1].line && temp[1].line.match(/open|clos|bal/i)) {
                partOfDescription = partOfDescription + ' ' + temp[1].line;
                temp1[0].line = '';
                temp1[1].line = partOfDescription + temp1[1].line;
              }
            } else {
              temp1.push(temp[0]);
              temp1.push(temp[1]);
            }
            if (temp[temp.length - 3].line) {
              if (temp[temp.length - 3].line.includes('-')) {
                temp[temp.length - 3].line = temp[temp.length - 3].line
                  .replace('-', '')
                  .trim();
                temp1.push(temp[temp.length - 3]);
              } else {
                temp1.push(temp[temp.length - 3]);
              }
            } else {
              temp1.push({
                line: '',
              });
            }
            if (temp[temp.length - 2]) {
              temp1.push(temp[temp.length - 2]);
            } else {
              temp1.push({
                line: '',
              });
            }
            temp1.push(temp[temp.length - 1]);
          } else if (
            temp.length === 4 &&
            header.length === 4 &&
            !header[3].line.match(/balan/i)
          ) {
            missingBalCol = true;
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            if (temp[2].line) {
              if (temp[2].line.includes('-')) {
                temp[2].line = temp[2].line.replace('-', '').trim();
                temp1.push(temp[2]);
              } else {
                temp1.push(temp[2]);
              }
            } else {
              temp1.push({
                line: '',
              });
            }
            if (temp[3].line) {
              temp1.push(temp[3]);
            } else {
              temp1.push({
                line: '',
              });
            }

            temp1.push({
              line: '',
            });
          } else if (temp.length === 4) {
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            temp1.push(temp[2]);
            temp1.push(temp[3]);
          } else if ( // credit card statement with no balance
            temp.length === 3 &&
            header.length === 3 &&
            header[2].line.match(/amount|debit/i) &&
            !header[2].line.match(/bal/i)
          ) {
            noBalanceColumn = true;
            temp1.push(temp[0]);
            temp1.push(temp[1]);
            if (temp[2].line) {
              if (temp[2].line.match(/[-]/)) {
                temp1.push(temp[2]);
                temp1.push({
                  line: '',
                });
              } else {
                temp1.push({
                  line: '',
                });
                temp1.push(temp[2]);
              }
            } else {
              temp1.push({
                line: '',
              });
            }
            temp1.push({
              line: '',
            });
          }

          modified.push(temp1);
        }
      }

      if (format === 'D + C') {
        // Check if any date column merged with description
       const trueConditionsCount = [totalCellsGreaterThanFive.length >= 1, totalCellsEqualsfive.length >= 1, totalCellsEqualsFour.length >= 1, totalCellsLessThanFour.length >= 1].filter(Boolean).length;
       if (trueConditionsCount === 1 && totalCellsEqualsFour.length > 0 && totalCellsEqualsFour[0][0].line && (totalCellsEqualsFour[0][0].line.match(datePatternWithoutYear))) {
        const col1Width = totalCellsEqualsFour[0][0].boundingPoly.vertices[1].x - totalCellsEqualsFour[0][0].boundingPoly.vertices[0].x;
        const col2Width = totalCellsEqualsFour[0][1].boundingPoly.vertices[1].x - totalCellsEqualsFour[0][1].boundingPoly.vertices[0].x;
        if (col1Width > col2Width) {
          this.generalErrors.push([
            totalCellsEqualsFour[0][0].pageIndex + 1,
            totalCellsEqualsFour[0][0].rowIndex,
            'Date column could be merged with description column',
            totalCellsEqualsFour[0]
          ]);
        }
       } else if (trueConditionsCount === 1 && totalCellsGreaterThanFive.length) {
        this.generalErrors.push([
          totalCellsGreaterThanFive[0][0].pageIndex + 1,
          totalCellsGreaterThanFive[0][0].rowIndex,
          'No of cells > 5',
          totalCellsGreaterThanFive[0]
        ]);
       }
       // If at least two arrays have length greater than 1
       if (trueConditionsCount >= 2) {
         // Find the array with the lesser number of cells but not 0
         const arrays = [];
         if (totalCellsGreaterThanFive.length > 0) arrays.push({ name: 'totalCellsGreaterThanFive', array: totalCellsGreaterThanFive });
         if (totalCellsEqualsfive.length > 0) arrays.push({ name: 'totalCellsEqualsfive', array: totalCellsEqualsfive });
         if (totalCellsEqualsFour.length > 0) arrays.push({ name: 'totalCellsEqualsFour', array: totalCellsEqualsFour });
         if (totalCellsLessThanFour.length > 0) arrays.push({ name: 'totalCellsLessThanFour', array: totalCellsLessThanFour });

         arrays.sort((a, b) => a.array.length - b.array.length);

         if (totalCellsLessThanFour.length > 0) {
          for (let i = 0; i < totalCellsLessThanFour.length; i++) {
            this.generalErrors.push([
              totalCellsLessThanFour[i][0].pageIndex + 1,
              totalCellsLessThanFour[i][0].rowIndex,
              'Inconsistencies in cell lengths',
              totalCellsLessThanFour[i]
            ]);
          }
        } else if (totalCellsGreaterThanFive.length > 0) {
          for (let i = 0; i < totalCellsGreaterThanFive.length; i++) {
            this.generalErrors.push([
              totalCellsGreaterThanFive[i][0].pageIndex + 1,
              totalCellsGreaterThanFive[i][0].rowIndex,
              'Inconsistencies in cell lengths',
              totalCellsGreaterThanFive[i]
            ]);
          }
        } else if (arrays.length > 0 && arrays[0].array) { // Return the array with the lesser number of cells but not 0
           this.generalErrors.push([
             arrays[0].array[0][0].pageIndex + 1,
             arrays[0].array[0][0].rowIndex,
             'Inconsistencies in cell lengths',
             arrays[0].array[0]
           ]);
         }
       }
      }

      const data = Helper.fixStatementsInReverseOrder(modified, tableArray);
      modified = data.filteredTableArray;
      if (data.reverseTrans && (this.pageIndex === 0 || this.userSwitchToNextStatement)) {
        this.dialogService.open(DialogComponent, {
          context: {
            body: `Transactions are typically listed in ascending order, but here they're in descending order, validation calculations are done in reverse order.`,
            header: "",
            dialogType: "info",
          },
          closeOnBackdropClick: false,
        });
      }
      // when balance missing from line add them
      if (format === 'D + C') {
        for (let i = 0; i < modified.length; i++) {
          if (modified[i][3] && !modified[i][3].line && modified[i - 1]) {
            let debitsCredits = modified[i][2].line
              ? modified[i][2].line.replace('$', '') : '';
              if (debitsCredits === '') continue;
            debitsCredits = parseFloat(debitsCredits);

            const balanceString = (modified[i - 1][3] && modified[i - 1][3].line) ? modified[i - 1][3].line.replace('$', ''): '';
            if (balanceString === '') continue;
            let balance: any = parseFloat(balanceString);

            if (balanceString && balanceString.match(/DR/i)) {
              if (balance > 0) balance = balance * -1;
            }
            const added: any = parseFloat(balance) + parseFloat(debitsCredits);
            let value = added;
            value = value.toFixed(2);
            modified[i][3].line = value.toString();
          } else if (i === 0 && missingBalCol) {
            let debitsCredits = modified[i][2].line
              ? modified[i][2].line.replace('$', '') : '';
            if (debitsCredits === '') continue;
            debitsCredits = parseFloat(debitsCredits);
            modified[i][3].line = debitsCredits.toString();
          }
        }
      } else if (format === 'D | C') {
        for (let i = 0; i < modified.length; i++) {
          if (modified[i][4] && !modified[i][4].line && modified[i - 1]) {
            let debitsCredits = modified[i][2].line
              ? '-' + modified[i][2].line.replace('$', '') : modified[i][3].line ? modified[i][3].line.replace('$', '') : '';
            if (debitsCredits === '') continue;
            debitsCredits = parseFloat(debitsCredits);

            const balanceString = modified[i - 1][4]?.line ? modified[i - 1][4].line.replace('$', ''): '';
            if (balanceString === '') continue;
            let balance: any = parseFloat(balanceString);

            if (balanceString && balanceString.match(/DR/i)) {
              if (balance > 0) balance = balance * -1;
            }
            const added: any = parseFloat(balance) + parseFloat(debitsCredits);
            let value = added;
            value = value.toFixed(2);
            modified[i][4].line = value.toString();
          } else if (i === 0 && missingBalCol) {
            let debitsCredits = modified[i][2].line
              ? '-' + modified[i][2].line.replace('$', '') : modified[i][3].line
              ? modified[i][3].line.replace('$', '') : '';
            if (debitsCredits === '') continue;
            debitsCredits = parseFloat(debitsCredits);
            modified[i][4].line = debitsCredits.toString();
          }
        }
      }

      const missingRows = Helper.checkEdgeRowsForGaps(modified, this.wordBlocks);
      if (missingRows && missingRows.length > 0) {
        this.generalErrors = this.generalErrors.concat(missingRows);
      }

      modified.noBalanceColumn = noBalanceColumn;
      return modified;
    } catch (err) {
      console.log('filterTableArray err', err);
    }
  }

  async export(e) {
    const format = e.format;

    const fileName = this.projectName + '.csv';
    if (Array.isArray(this.extractedResultsFull)) {
      await this.dialogService
      .open(DialogComponent, {
        context: {
          body: '!!! Please Confirm !!!',
          header: 'Do you want to export all jobs?',
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe(async (data) => {
        if (data && data.value === 'YES') {
          const body = {
            projectName: this.projectName,
            userEmail: this.userEmail,
          };
          this.api.getJobs(body).subscribe(async (res) => {
            res.sort(function (a, b) {
              const c: any = new Date(a.createdAt);
              const d: any = new Date(b.createdAt);
              return d - c;
            });
            let sheet1 = [];
            let sheet2 = [];
            console.log('res', res)
            for (let i = 0; i < res.length; i++) {
              if (res[i].status === 'IN_QUEUE') {
                alert('Please wait until all jobs are processed.');
                return;
              }
              const initData: any = await this.api.downloadJSONFromS3(res[i].s3SignedExtractedResults).toPromise();
              function removeSymbolsFromKeysInArray(jsonArray) {
                return jsonArray.map(obj => {
                  const newObj = {};
                  for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                      // Remove symbols from the key
                      const newKey = key.replace(/[^a-zA-Z0-9]/g, '');
                      newObj[newKey] = obj[key];
                    }
                  }
                  return newObj;
                });
              }
              const extractedResults = removeSymbolsFromKeysInArray(initData);
              const data = extractedResults.find(invoice => invoice.lineItems && invoice.lineItems.length > 0) || extractedResults[0];
              // Function to add missing fields to selectedInvoice
              function addMissingFields(selectedInvoice, allInvoices) {
                allInvoices.forEach(invoice => {
                    if (invoice !== selectedInvoice) {
                        Object.keys(invoice).forEach(key => {
                            if (!selectedInvoice.hasOwnProperty(key)) {
                                selectedInvoice[key] = invoice[key];
                            }
                        });
                    }
                });
              }

              // Add missing fields from all other invoices to the selected invoice
              addMissingFields(data, extractedResults);

              if (data.pt) {
                data.receiverName = data.pt;
              } else if (data.re) {
                data.receiverName = data.re;
              }

              if (!data.bsb) {
                Object.keys(data).forEach(key => {
                  // Check if the key contains 'Bsb' and if the corresponding value contains a number
                  if (key.includes('Bsb') && data[key] && /\d+/.test(data[key])) {
                    // Assign the value to this.selectedInvoice.bsb if it's not already assigned
                    if (!data.bsb) { // dlete
                      data.bsb = data[key];
                    }
                  }
                });
              }

              if (data.lineItems) {
                for (let i = 0; i < data.lineItems.length; i++) {
                  const hasDateKey = Object.keys(data.lineItems[i]).some(key => key.toLowerCase().includes('date'));
                  if (!hasDateKey) {
                    const priorityKeys = ['receiptdate', 'invoicedate', 'date']; 
                    for (const key of priorityKeys) {
                      const dateEntry = Object.entries(data).find(
                        ([entryKey, value]) => entryKey.toLowerCase().includes(key)
                      );
            
                      if (dateEntry) {
                        const [dateKey, dateValue] = dateEntry;
                        data.lineItems[i]['date'] = dateValue;
                        break; // Stop after finding the first matching entry
                      }
                    }
                  }
                  if (data.lineItems[i])
                  delete data.lineItems[i].expenseRow
                }
              }

              const {sheet1Data, sheet2Data} = this.generateExcelContent(data, i + 1);
              sheet1 = sheet1.concat(sheet1Data);
              sheet2 = sheet2.concat(sheet2Data);
            }
            this.generateExcel(sheet1, sheet2, this.projectName);
          });
        } else {
          const body = {
            projectName: this.projectName,
            userEmail: this.userEmail,
          };
          const allJobs = await this.api.getJobs(body).toPromise();
          allJobs.sort(function (a, b) {
            const c: any = new Date(a.createdAt);
            const d: any = new Date(b.createdAt);
            return d - c;
          });

          function findIndexById(array, id) {
            return array.findIndex(element => element.jobId === id);
          }
          const index = findIndexById(allJobs, this.jobId)

          const {sheet1Data, sheet2Data} = this.generateExcelContent(this.selectedInvoice, index + 1);
          this.generateExcel(sheet1Data, sheet2Data, this.jobId);
        }
      });
    } else {
      // const content = this.formatCsvContent(format, this.extractedRes);
      // downloadjs(content, fileName, 'text/csv');
    }
  }

  generateExcelContent(data, jobId) {
    const dateKeys = ['date', 'serviceDate', 'visitDate'];
    const memoKeys = ['receiverPatientName', 'receiverPatient', 'receiverName', 'receiverAddress'];
    const netKeys = ['amount', 'invoiceAmount', 'value', 'price', 'fees', 'fee'];
    const feeKeys = ['fees', 'fee',];
    const taxKeys = ['gst', 'gstAmount'];
    const invoiceNoKeys = ['invoiceNo', 'invoiceReceiptId', 'File#'];

    function normalizeKey(key: string): string {
      return key.replace(/[\s:]/g, '').toLowerCase();
    }    

    const findFirstValidKey = (obj: { [key: string]: any }, keys: string[]): any => {
      const normalizeKey = (key: string) => key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase(); // Assuming normalizeKey function
    
      for (const key of keys) {
        const normalizedKey = normalizeKey(key);
        for (const objKey in obj) {
          if (obj.hasOwnProperty(objKey)) {
            if (normalizedKey === 'description' && obj[objKey]) {
              const match = objKey.match(/description/i);
              if (match) {
                return obj[objKey].replace(/[\r\n]/g, ''); // Remove newline characters
              }
            }
            if (normalizeKey(objKey) === normalizedKey) {
              if (obj[objKey]) {
                return obj[objKey].replace(/[\r\n]/g, ''); // Remove newline characters
              }
              return obj[objKey].replace(/[\r\n]/g, ''); // Remove newline characters
            }
          }
        }
      }
      return '';
    };

    const invoiceNo = findFirstValidKey(data, invoiceNoKeys);
    const sheet1Data = [];
    let memo = findFirstValidKey(data, memoKeys);
    const reference = String(jobId).padStart(3, '0');
    let accountCode = 'AP';
    let tax = '';
    let taxCode = '';
    let lookupId = jobId;
    let netTotal = 0;
    sheet1Data.push([reference, '', memo, accountCode, netTotal, tax, taxCode, lookupId, invoiceNo]);
    for (let i = 0;  i < data.lineItems.length; i++) {
      let entryDate = findFirstValidKey(data.lineItems[i], dateKeys);
      if (!entryDate) {
        const priorityKeys = ['receiptdate', 'invoicedate', 'date'];
        for (const key of priorityKeys) {
          const dateEntry = Object.entries(data).find(
            ([entryKey, value]) => entryKey.toLowerCase().includes(key)
          );

          if (dateEntry) {
            const [dateKey, dateValue] = dateEntry;
            entryDate = dateValue;
            break; // Stop after finding the first matching entry
          }
        }
      }
      let memo = '';
      const accountCode = 'M';
      const net = findFirstValidKey(data.lineItems[i], netKeys);
      let fee = findFirstValidKey(data.lineItems[i], feeKeys);
      let tax = findFirstValidKey(data.lineItems[i], taxKeys);
      if (!fee && typeof net === 'string' && net.trim() !== '') { // identify fee from gast
        let parsedNet = parseFloat(net.replace(/[^0-9.-]+/g, ""));
        let noGst = false;
        if (tax && tax.match(/(\$0\.00|0\.00)/)) {
          noGst = true;
        }
        // Check if parsedNet is a valid number
        if (!isNaN(parsedNet) && parsedNet > 0) {
          fee = noGst ? parsedNet : Math.round(parsedNet / 1.10);
          if (!tax) {
            let taxRate = 10;
            let amountExcludingGST = parsedNet / (1 + taxRate / 100);
            tax = Math.round(parsedNet - amountExcludingGST);
          }
        }
      }
      // if (!tax && fee) {
      //   fee = parseFloat(fee.replace(/[^0-9.-]+/g, "")); // Convert fee to a number if it's a string
      //   let taxRate = 10;
      //   let parsedNetWithGST = fee * (1 + taxRate / 100);
      //   console.log('parsedNetWithGST', parsedNetWithGST.toFixed(2));

      // }
      let taxCode =  'NCF';
      // tax ?  'NCG'
      if (tax) {
        let parsedTax = parseFloat(tax);
        if (!isNaN(parsedTax) && parsedTax > 0) {
          taxCode = 'NCG';
        }
      }
      const lookupId = '';
      const invoiceNo = '';
      if (typeof net === 'string' && net.trim() !== '') {
        let parsedNet = parseFloat(net.replace(/[^0-9.-]+/g, ""));
        // Check if parsedNet is a valid number
        if (!isNaN(parsedNet)) {
            netTotal += parsedNet;
        } else {
            console.error(`Error: Invalid number format for net value "${net}"`);
        }
      }
      function extractNumber(fee) {
        if (fee && typeof fee === 'string') {
            return Number(fee.replace(/[^0-9.]/g, ''));
        } else if (typeof fee === 'number') {
            return fee;
        } else {
            return NaN; // or handle the error as appropriate
        }
    }
      if (fee) {
        fee = extractNumber(fee)
      }
      if (tax) {
        tax = extractNumber(tax)
      }
      sheet1Data.push([reference, entryDate, memo, accountCode, fee, tax, taxCode, lookupId, invoiceNo]);
    }
    if (netTotal > 0) netTotal = netTotal * -1;
    sheet1Data[0][4] = netTotal;


    const namekeys = ['vendorName'];
    const abnKeys = ['vendorAbnNumber'];
    const accountNokeys = ["accountNumber", "A/c No.", 'accountNo', 'ACC:', 'accNo', 'acctNo', 'Acct', 'account:'];
    const accountNamekeys = ['accountName', 'vendorAccountName', 'vendorName'];
    const bsbKeys = ['bsb'];
    const emailKeys = ['email'];
    const name = findFirstValidKey(data, namekeys);
    const abn = findFirstValidKey(data, abnKeys);
    const email = findFirstValidKey(data, emailKeys);
    let accountName = findFirstValidKey(data, accountNamekeys);
    if (accountName) {
      accountName = accountName.replace('A/C', '')
    }
    let bsb = findFirstValidKey(data, bsbKeys);
    if (bsb) {
      bsb = bsb.replace(/\D/g, '');
    }
    const accountNo = findFirstValidKey(data, accountNokeys);
    const eftMethod = 'EFT';
    const remiteeEmail = '';
    
    const sheet2Data = [
      [jobId, name, abn, email, eftMethod, accountName, bsb, accountNo, remiteeEmail]
    ];


    return {sheet1Data, sheet2Data}
  }

  generateExcel(sheet1Data, sheet2Data, fileName) {
    const sheet1Header = ['Reference', 'Entry Date', 'Memo', 'Account Code', 'Net', 'Tax', 'Tax Code', 'Lookup ID', 'Invoice No'];
    const sheet1 = [sheet1Header, ...sheet1Data];

    const sheet2Header = ['Lookup ID', 'Name', 'ABN', 'Email', 'EFT Method', 'Account Name', 'BSB', 'Account No', 'Remittee Email'];
    const sheet2 = [sheet2Header, ...sheet2Data]

    const worksheet1: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheet1);
    const worksheet2: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheet2);

    const workbook: XLSX.WorkBook = {
      Sheets: {
        'Sheet1': worksheet1,
        'Sheet2': worksheet2
      },
      SheetNames: ['Sheet1', 'Sheet2']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    downloadjs(data, `${fileName}_export_${new Date().getTime()}.xlsx`, EXCEL_TYPE);
  }

  formatCsvContent (format, extractedRes) {
    this.replaceMissingDates(extractedRes);
    let content = `Bank Name,Bsb,Account Number,Account Name,Client Name,Client Address,Opening Statement Date,Closing Statement Date,`;
    const formatString = (string) => {
      if (!string) return '';
      return string.replace(/[;]/g, '||').replace(/[,]/g, '~')
    }
    const standardVal = `${formatString(extractedRes.bankName)},${extractedRes.bsb
      },${extractedRes.accountNumber},${formatString(extractedRes.accountName)},${formatString(extractedRes.clientName)
      },${formatString(extractedRes.clientAddress)},${this.dtTd(extractedRes.openingStatementDate)},${this.dtTd(extractedRes.closingStatementDate)}`;

    const { tableArray, header } = this.getTableArray(false, extractedRes);
    let filteredTableArray;
    if (format === '1') {
      content += 'Date, Transaction Details, Credit/(Debit), Balance(DR/CR)' + '\n';
      filteredTableArray = this.filterTableArray(tableArray, header);
    } else if (format === '2') {
      content +=
        'Date, Transaction Details, Debit, Credit, Balance(DR/CR)' + '\n';
      filteredTableArray = this.filterTableArray(tableArray, header, 'D | C');
    }

    const tableStringArray = [];
    let invalidDate = false;
    for (const item of filteredTableArray) {
      const temp = item;
      const temp1 = [];
      let wrapedToNextPage = false;
      for (let i = 0; i < temp.length; i++) {
        if (i === temp.length - 1) {
          if (temp[i].line && temp[i].line.match(/CR/i)) {
            temp[i].line = temp[i].line.replace(/CR/i, '');
          } else if (temp[i].line && temp[i].line.match(/DR/i)) {
            temp[i].line = '-' + temp[i].line.replace(/DR/i, '');
          }
        }
        const line = temp[i].topLine ? temp[i].topLine + ' ' + temp[i].line : temp[i].line;
        if (temp[i].topLine) {
          wrapedToNextPage = true;
        }
        temp1.push(line.trim());
      }

      if (wrapedToNextPage && format === '2') {
        tableStringArray.pop();
      }

      if (format === '1') {
        temp1[2] = temp1[2] === ' ' ? 0 : temp1[2];
      } else if (format === '2') {
        temp1[2] = temp1[2] === ' ' ? 0 : temp1[2];
        temp1[3] = temp1[3] === ' ' ? 0 : temp1[3];
        temp1[4] = (temp1[4] === ' ' && !filteredTableArray.noBalanceColumn) ? 0 : temp1[4];
      }

      const formattedDate = MomentService.applyStandardDateFormat(temp1[0]);
      if (formattedDate) {
        temp1[0] = formattedDate;
      }
      if (!formattedDate && temp1[1] && !temp1[1].match(/OPENING BALANCE|CLOSING BALANCE/i)) invalidDate = true;

      tableStringArray.push(`${standardVal},${temp1.join(',')}`);
    }

    // if (invalidDate) {
    //   this.dialogService.open(DialogComponent, {
    //     context: {
    //       body: "!!! Please check if all rows in the exported file contain valid date. !!!",
    //       header: "Warning",
    //       dialogType: "info",
    //     },
    //     closeOnBackdropClick: false,
    //   });
    // }
    tableStringArray.push('', '', '');
    const tableContent = tableStringArray.join('\n');

    content += tableContent;
    return content;
  }

  filterWords(wordsAnnotationArray) {
    if (!wordsAnnotationArray) return null;
    if (wordsAnnotationArray.length === 0) return '';
    let string = '';
    for (const word of wordsAnnotationArray) {
      /**
       * Fixed corner case where textract identifies '.' as ','
       * e.g. expeted: '72.55', textract: '72,55' 
       */
      const RE = /\d{2},\d{2}/;
      let description = ''
      if (RE.test(word.description) && word.description.length === 5) {
        description = word.description.replace(',', '.')
      } else {
        description = word.description
        ? word.description.replace(/,/g, '')
        : ''; 
      }
      string = string + ' ' + description.trim();
    }
    return string.trim();
  }


  resizeTextAnnotationsResolution(
    textAnnotations,
    pageBoundingPoly,
    newWidth,
    newHeight,
  ) {
    let newTextAnnotations;
    if (!Array.isArray(textAnnotations)) {
      return textAnnotations;
    } else {
      newTextAnnotations = textAnnotations;
      let changeWidthHeightOrBoth;
      if (newWidth > 0 && newHeight > 0) {
        changeWidthHeightOrBoth = 'B';
      } else if (newWidth > 0) {
        changeWidthHeightOrBoth = 'W';
      } else if (newHeight > 0) {
        changeWidthHeightOrBoth = 'H';
      } else return;
      const modifier = { x: 1, y: 1 }; // a modifer of 1 is no change to the coordinate.
      try {
        const bounds = this.getWholeTextBound(pageBoundingPoly);
        for (let i = 0; i < newTextAnnotations.length; i++) {
          // calculate the new modifier value for each page:
          if (changeWidthHeightOrBoth === 'W') {
            modifier.x = newWidth / bounds.width;
            modifier.y = modifier.x; // modify both x and y by same ammount to preserve aspect ratio
          } else if (changeWidthHeightOrBoth === 'H') {
            modifier.y = newHeight / bounds.height;
            modifier.x = modifier.y; // modify both x and y by same ammount to preserve aspect ratio
          } else if (changeWidthHeightOrBoth === 'B') {
            modifier.x = newWidth / bounds.width;
            modifier.y = newHeight / bounds.height;
          }
          for (let j = 0; j < newTextAnnotations[i].length; j++) {
            for (let k = 0; k < 4; k++) {
              const vertex = newTextAnnotations[i][j].boundingPoly.vertices[k];
              vertex.x = Math.round(vertex.x * modifier.x);
              vertex.y = Math.round(vertex.y * modifier.y);
            }
          }
        }
      } catch (err) {}
      return newTextAnnotations;
    }
  }

  jobVerifiedStatus(e) {
    if (e.jobId !== this.jobId) {
      console.log('jobId does not match')
      return;
    }
    const status = e.status;
    const currentVerificationStatus = this.status;
    if (status === 'W') {
      this.status = 'Processed';
      this.statusColor = 'warning';
    } else if (status === 'V') {
      this.status = 'Verified';
      this.statusColor = 'success';
    } else if (status === 'F') {
      this.status = 'Failed';
      this.statusColor = 'danger';
    }
    if (currentVerificationStatus === this.status) {
      console.log('Status been updated already');
      return;
    }
    this.api
      .updateJobVerificationStatus({
        jobId: e.jobId,
        newStatus: this.status,
        currentValue: currentVerificationStatus,
      })
      .subscribe((res) => {
        if (res.success) {
          this.toastrService.success(
            'Successfully updated job verification.',
            `Success`,
          );
          this.injectToHeaderToolbar();
        } else {
          this.toastrService.danger(
            'Failed updating job verification.',
            `Success`,
          );
        }
      });
    return;
  }

  setVerificationStatusColor() {
    if (this.status === 'Verified') {
      this.statusColor = 'success';
    } else if (this.status === 'Processed') {
      this.statusColor = 'warning';
    } else if (this.status === 'Failed') {
      this.statusColor = 'danger';
    }
  }

  onReprocessClick() {
    this.loading = true;
    const payload = {
      jobId: this.jobId,
      deskewedImageS3Keys: this.deskewedImageS3Keys
    };
    this.api.reprocess(payload).subscribe((res: any) => {
      if (res && res.success) {
        this.toastrService.success("Reprocessed successfully", `success`, {
          destroyByClick: true,
          duration: 600000000,
        });
        this.loading = false;
        window.open(`/pages/job/${this.jobId}`, "_self");
      } else if (
        res &&
        this.imgURLs.length > 20 &&
        res.message === "TimeoutError"
      ) {
        this.toastrService.danger(
          "Total pages exceeds normal limit",
          `Processing in background. Check back in a few minutes for an update.`,
          { destroyByClick: true, duration: 600000000 }
        );
        this.loading = false;
      } else if (res && res.message === "TimeoutError") {
        this.toastrService.danger(
          "Reprocess Failed",
          `API Gateway has timed out after 30 seconds`,
          { destroyByClick: true, duration: 600000000 }
        );
      } else {
        this.toastrService.danger("Reprocess Failed", `Please Try Again`, {
          destroyByClick: true,
          duration: 600000000,
        });
      }
    });
  }

  onPopverAddCommentClick() {
    this.dialogService
      .open(AddCommentsComponent, {
        context: {
          comments: this.comments,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((data) => {
        if (data && data.submit) {
          this.api
            .updateComments({
              jobId: this.jobId,
              comments: data.comments,
            })
            .subscribe((res) => {
              if (res.success) {
                this.comments = data.comments;
                this.toastrService.success(
                  'Successfully updated comments.',
                  `Success`,
                  {
                    position: this.toastrPosition,
                    duration: 0,
                  },
                );
              } else {
                this.toastrService.danger(
                  'Failed updating job comments.',
                  `Failed`,
                  {
                    position: this.toastrPosition,
                    duration: 0,
                  },
                );
              }
            });
        }
      });
  }

  updateDate(date, field) {
    this.extractedRes[field] = date;
    this.save();
  }

  updateOtherFields() {
    this.save();
  }

  async save() {
    this.revertSubstitutedValues();
    this.extractedRes.openingStatementDate = this.dtTd(this.extractedRes.openingStatementDate);
    this.extractedRes.closingStatementDate = this.dtTd(this.extractedRes.closingStatementDate);

    let statementIndex;
    const currentPageTransactionDetails = this.extractedRes.transactionDetails.filter((item) => {
      if (item.pageIndex === this.pageIndex) {
        return item;
      }
    });
    if (Array.isArray(this.extractedResultsFull)) { // If multiple statements are combined,
      this.extractedResultsFull.filter((item, index) => {
        if (item.startPageNo === this.extractedRes.startPageNo) {
          statementIndex = index;
        }
      });
    }

    const headers = deepCopy(this.extractedRes);
    delete headers.transactionDetails;
    delete headers.wordBlocks;
    this.api
      .updateExtractedRes({
        jobId: this.jobId,
        multipleStatementsCombined: (Array.isArray(this.extractedResultsFull) && this.extractedResultsFull.length > 0) ? true : false,
        statementIndex: statementIndex,
        headers: headers,
        extractedResKey: this.extractedResKey,
        currentPageTransactionDetails: currentPageTransactionDetails.length > 0 ? currentPageTransactionDetails[0] : null
      })
      .subscribe(async (res) => {
        if (res.success) {
          this.toastrService.success('Successfully updated.', `Success`, {
            position: this.toastrPosition,
            duration: 600,
          });
          // await this.getJob(this.jobId, true, this.statementNo);
        } else {
          this.toastrService.danger('Failed updating job.', `Success`, {
            position: this.toastrPosition,
            duration: 600,
          });
        }
      });
  }

  async proceedToNextJob(res) {
    const goToPreviousJob = res.loc === "previous" ? true : false;
    const body = {
      projectName: this.projectName,
      userEmail: this.userEmail,
    };
    this.api.getJobs(body).subscribe((res) => {
      res.sort(function (a, b) {
        const c: any = new Date(a.createdAt);
        const d: any = new Date(b.createdAt);
        return d - c;
      });
      let nextJobId = null;
      let message = '';
      for (let i = 0; i < res.length; i++) {
        if (res[i].jobId === this.jobId) {
          if (goToPreviousJob) {
            if (!res[i - 1]) {
              message = 'No more jobs to view; you are currently viewing the first one on the list.';
            } else if (res[i - 1] && res[i - 1].status === 'IN_QUEUE') {
              message = 'The status of the previous job is still in the queue';
            } else {
              nextJobId = res[i - 1].jobId;
            }
            break;
          } else {
            if (!res[i + 1]) {
              message = 'No more jobs to view; you are currently viewing the last one on the list.';
            } else if (res[i + 1] && res[i + 1].status === 'IN_QUEUE') {
              message = 'The status of the next job is still in the queue';
            } else {
              nextJobId = res[i + 1].jobId;
            }
            break;
          }
        }
      }
      if (nextJobId) {
        window.open(`/pages/job/${nextJobId}`, '_self');
      } else {
        this.dialogService.open(DialogComponent, {
          context: {
            body: `${message}`,
            header: "",
            dialogType: "info",
          },
          closeOnBackdropClick: false,
        });
      }
    });
  }


  inputPageNumber(event) {
    if (
      event.target.value - 1 < 0 ||
      event.target.value - 1 >= this.imgSrc.length
    ) {
      this.changePage(0, null);
    } else {
      this.changePage(event.target.value - 1, null);
    }
  }

  resetErrPgClick(value) {
    this.errorPageClick = value;
    return value;
  }

  showErrorPage(direction, event) {
    // event.stopPropagation()
    this.errorPagesConsolidated.sort();
    if (direction === 'F') {
      this.errorPageClick += 1;
    } else if (direction === 'B') {
      this.errorPageClick -= 1;
    }

    this.errorPage = this.errorPagesConsolidated[this.errorPageClick - 1];
    this.changePage(this.errorPage - 1, 'errorPageNav');
  }

  createDate(date: string) {
    if (MomentService.isValidDate(date)) {
      return new Date(date);
    } else {
      return '';
    }
  }

  dtTd(dateTime: string) {
    if (!dateTime) return '';
    return MomentService.datetimeToDate(dateTime);
  }

  exportAnnotations(format) {
    const target = (format === 'A-R') ? this.extractedRes : format === 'A-A'
      ? this.resizeResolution(
          this.extractedRes,
          standardCanvasWidth,
          standardCanvasHeight,
          true,
        )
      : null;
    // this.revertSubstitutedValues();
    const fileName = `${this.jobId}-${format}`;
    const data: any = {
      data: target.allTables,
    };
    const blob = new Blob([JSON.stringify(data)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    // Create a new anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();
    if (format === 'A-A') {
      this.resizeResolution(
        this.extractedRes,
        standardCanvasWidth,
        standardCanvasHeight,
        false,
      );
    }
  }

  layerButton() {
    this.showWordBlocks = !this.showWordBlocks;
    this.drawCanvas(true);
  }

  horizontalButton() {
    this.lineDraw = true;
    this.headerToggle(null);
    this.imageBoxEditor.horizontalButton();
  }

  verticalButton() {
    this.lineDraw = true;
    this.headerToggle(null);
    this.imageBoxEditor.verticalButton();
  }

  undoButton() {
    this.lineDraw = false;
    this.headerToggle(null);
    this.imageBoxEditor.undoButton();
  }

  proceedButton() {
    this.lineDraw = false;
    this.headerToggle(null);
    this.imageBoxEditor.proceedButton();
  }

  async undoTableChanges() {
    const prevChange = this.changes[this.changes.length - 1];
    this.extractedRes.transactionDetails = prevChange.transactionDetails;
    this.changes.pop();
    await this.drawCanvas(true);
  }

  onPopverInfoClick() {
    this.dialogService
      .open(InfoComponent, {
        context: {
          fileName: this.fileName,
          projectName: this.projectName,
          owner: this.jobOwner
        },
        closeOnBackdropClick: false,
      });
  }

  async deskewImage(info) {
    const direction = info.direction;
    if (direction) {
        // clear left image context
        this.leftContext.clearRect(
        0,
        0,
        this.leftImageCanvas.nativeElement.width,
        this.leftImageCanvas.nativeElement.height,
        );

        this.updateSkewFactors(direction, info.userDefinedSkewFactor);
        this.injectToHeaderToolbar();
        this.leftContext.setTransform(1, this.skewFactorX, this.skewFactorY, 1, 0, 0);
        //draw updated image on left context
        this.leftContext.drawImage(
          this.leftImage,
          0,
          0,
          this.leftImage.width,
          this.leftImage.height,
        );
    } else if (info.function === 'save') {
        await this.saveImage();
    }
}


updateSkewFactors(direction, userDefinedSkewFactor) {
    switch (direction) {
        case 'x-':
            this.skewFactorX -= 0.001;
            break;
        case 'x+':
            this.skewFactorX += 0.001;
            break;
        case 'y-':
            this.skewFactorY -= 0.001;
            break;
        case 'y+':
            this.skewFactorY += 0.001;
            break;
        case 'reset':
            this.skewFactorX = 0;
            this.skewFactorY = 0;
            break;
        case 'x':
            this.skewFactorX = userDefinedSkewFactor;
            break;
        case 'y':
            this.skewFactorY = userDefinedSkewFactor;
            break;
        default:
            break;
    }
    this.skewFactorX = Math.round(this.skewFactorX * 1000) / 1000;
    this.skewFactorY = Math.round(this.skewFactorY * 1000) / 1000;
}

  async saveImage() {
      const canvas = this.leftImageCanvas.nativeElement;
      let imageData = canvas.toDataURL("image/jpeg");
      let imgSize = getImageSizeFromDataURL(imageData);
      let maxSize = 2 * 1024 * 1024; // 2 MB in bytes
      if (imgSize > maxSize) {
          imageData = canvas.toDataURL("image/jpeg", 0.5);
      }
      const { fileName } = getFileNameAndExtOfPath(this.imageKeys[this.pageIndex])
      const imageKey = fileName + '-skewFix.' + 'jpeg';
      const body = {
          key: imageKey,
          contentType: 'image/jpeg',
          userEmail: this.userEmail,
      };
      try {
          const result = await this.api.getUploadUrl(body).toPromise();
          var blob: any = dataURItoBlob(imageData);
          const res: any = await this.uploadFile(result.signedUrl, blob).toPromise();
          if (res.status === 200) {
              this.toastrService.success(
                  'Successfully saved image',
                  `Success`,
              );
              this.imgSrc[this.pageIndex] = await blobToBase64(blob);
              this.deskewedImageS3Keys[this.pageIndex] = imageKey;
          } else {
              this.toastrService.danger(
                  'Failed saving image',
                  `Success`,
              );
          }
      } catch (error) {
          console.error('Error saving image:', error);
          this.toastrService.danger(
              'Failed saving image',
              `Success`,
          );
      }
  }

  uploadFile<R>(url: string, file: File): Observable<HttpEvent<R>> {
    const params = new HttpParams();
    const headers = new HttpHeaders()
      .set('Content-Type', file.type)
      .set('X-Skip-Header-Authorization', '');

    const options = {
      params,
      reportProgress: true,
      headers,
    };

    const req = new HttpRequest('PUT', url, file, options);
    return this.http.request(req);
  }
}

function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
